import gql from "graphql-tag";
/** The strategy to apply coupons to the cart. */
export var IApplyCouponsStrategy;
(function (IApplyCouponsStrategy) {
    /** Append new coupons keeping the coupons that have been applied before. */
    IApplyCouponsStrategy["Append"] = "APPEND";
    /** Remove all the coupons from the cart and apply only new provided coupons. */
    IApplyCouponsStrategy["Replace"] = "REPLACE";
})(IApplyCouponsStrategy || (IApplyCouponsStrategy = {}));
/** List of all entity types. Populated by the modules introducing EAV entities. */
export var IAttributeEntityTypeEnum;
(function (IAttributeEntityTypeEnum) {
    IAttributeEntityTypeEnum["CatalogProduct"] = "CATALOG_PRODUCT";
    IAttributeEntityTypeEnum["CatalogCategory"] = "CATALOG_CATEGORY";
    IAttributeEntityTypeEnum["Customer"] = "CUSTOMER";
    IAttributeEntityTypeEnum["CustomerAddress"] = "CUSTOMER_ADDRESS";
    IAttributeEntityTypeEnum["RmaItem"] = "RMA_ITEM";
})(IAttributeEntityTypeEnum || (IAttributeEntityTypeEnum = {}));
/** EAV attribute frontend input types. */
export var IAttributeFrontendInputEnum;
(function (IAttributeFrontendInputEnum) {
    IAttributeFrontendInputEnum["Boolean"] = "BOOLEAN";
    IAttributeFrontendInputEnum["Date"] = "DATE";
    IAttributeFrontendInputEnum["Datetime"] = "DATETIME";
    IAttributeFrontendInputEnum["File"] = "FILE";
    IAttributeFrontendInputEnum["Gallery"] = "GALLERY";
    IAttributeFrontendInputEnum["Hidden"] = "HIDDEN";
    IAttributeFrontendInputEnum["Image"] = "IMAGE";
    IAttributeFrontendInputEnum["MediaImage"] = "MEDIA_IMAGE";
    IAttributeFrontendInputEnum["Multiline"] = "MULTILINE";
    IAttributeFrontendInputEnum["Multiselect"] = "MULTISELECT";
    IAttributeFrontendInputEnum["Price"] = "PRICE";
    IAttributeFrontendInputEnum["Select"] = "SELECT";
    IAttributeFrontendInputEnum["Text"] = "TEXT";
    IAttributeFrontendInputEnum["Textarea"] = "TEXTAREA";
    IAttributeFrontendInputEnum["Weight"] = "WEIGHT";
    IAttributeFrontendInputEnum["Undefined"] = "UNDEFINED";
})(IAttributeFrontendInputEnum || (IAttributeFrontendInputEnum = {}));
/** Attribute metadata retrieval error types. */
export var IAttributeMetadataErrorType;
(function (IAttributeMetadataErrorType) {
    /** The requested entity was not found. */
    IAttributeMetadataErrorType["EntityNotFound"] = "ENTITY_NOT_FOUND";
    /** The requested attribute was not found. */
    IAttributeMetadataErrorType["AttributeNotFound"] = "ATTRIBUTE_NOT_FOUND";
    /** The filter cannot be applied as it does not belong to the entity */
    IAttributeMetadataErrorType["FilterNotFound"] = "FILTER_NOT_FOUND";
    /** Not categorized error, see the error message. */
    IAttributeMetadataErrorType["Undefined"] = "UNDEFINED";
})(IAttributeMetadataErrorType || (IAttributeMetadataErrorType = {}));
export var IBatchMutationStatus;
(function (IBatchMutationStatus) {
    IBatchMutationStatus["Success"] = "SUCCESS";
    IBatchMutationStatus["Failure"] = "FAILURE";
    IBatchMutationStatus["MixedResults"] = "MIXED_RESULTS";
})(IBatchMutationStatus || (IBatchMutationStatus = {}));
export var ICartDiscountType;
(function (ICartDiscountType) {
    ICartDiscountType["Item"] = "ITEM";
    ICartDiscountType["Shipping"] = "SHIPPING";
})(ICartDiscountType || (ICartDiscountType = {}));
export var ICartItemErrorType;
(function (ICartItemErrorType) {
    ICartItemErrorType["Undefined"] = "UNDEFINED";
    ICartItemErrorType["ItemQty"] = "ITEM_QTY";
    ICartItemErrorType["ItemIncrements"] = "ITEM_INCREMENTS";
    ICartItemErrorType["ItemIncrement"] = "ITEM_INCREMENT";
    ICartItemErrorType["CartonsLimit"] = "CARTONS_LIMIT";
    ICartItemErrorType["OngoingSubscription"] = "ONGOING_SUBSCRIPTION";
    ICartItemErrorType["TradeinLimit"] = "TRADEIN_LIMIT";
    ICartItemErrorType["FreegiftsUnavailable"] = "FREEGIFTS_UNAVAILABLE";
    ICartItemErrorType["FreegiftsNoSuchParent"] = "FREEGIFTS_NO_SUCH_PARENT";
    ICartItemErrorType["FreegiftsNoSuchChild"] = "FREEGIFTS_NO_SUCH_CHILD";
    ICartItemErrorType["FreegiftsQtyError"] = "FREEGIFTS_QTY_ERROR";
})(ICartItemErrorType || (ICartItemErrorType = {}));
export var ICartUserInputErrorType;
(function (ICartUserInputErrorType) {
    ICartUserInputErrorType["ProductNotFound"] = "PRODUCT_NOT_FOUND";
    ICartUserInputErrorType["NotSalable"] = "NOT_SALABLE";
    ICartUserInputErrorType["InsufficientStock"] = "INSUFFICIENT_STOCK";
    ICartUserInputErrorType["Undefined"] = "UNDEFINED";
    ICartUserInputErrorType["PermissionDenied"] = "PERMISSION_DENIED";
    /** 2.4.6 adaptation to errors being thrown in graphql */
    ICartUserInputErrorType["GiftError"] = "GIFT_ERROR";
})(ICartUserInputErrorType || (ICartUserInputErrorType = {}));
export var ICatalogAttributeApplyToEnum;
(function (ICatalogAttributeApplyToEnum) {
    ICatalogAttributeApplyToEnum["Simple"] = "SIMPLE";
    ICatalogAttributeApplyToEnum["Virtual"] = "VIRTUAL";
    ICatalogAttributeApplyToEnum["Bundle"] = "BUNDLE";
    ICatalogAttributeApplyToEnum["Downloadable"] = "DOWNLOADABLE";
    ICatalogAttributeApplyToEnum["Configurable"] = "CONFIGURABLE";
    ICatalogAttributeApplyToEnum["Grouped"] = "GROUPED";
    ICatalogAttributeApplyToEnum["Category"] = "CATEGORY";
})(ICatalogAttributeApplyToEnum || (ICatalogAttributeApplyToEnum = {}));
/** Indicates how agreements are accepted. */
export var ICheckoutAgreementMode;
(function (ICheckoutAgreementMode) {
    /** Conditions are automatically accepted upon checkout. */
    ICheckoutAgreementMode["Auto"] = "AUTO";
    /** Shoppers must manually accept the conditions to place an order. */
    ICheckoutAgreementMode["Manual"] = "MANUAL";
})(ICheckoutAgreementMode || (ICheckoutAgreementMode = {}));
export var ICheckoutUserInputErrorCodes;
(function (ICheckoutUserInputErrorCodes) {
    ICheckoutUserInputErrorCodes["ReorderNotAvailable"] = "REORDER_NOT_AVAILABLE";
    ICheckoutUserInputErrorCodes["ProductNotFound"] = "PRODUCT_NOT_FOUND";
    ICheckoutUserInputErrorCodes["NotSalable"] = "NOT_SALABLE";
    ICheckoutUserInputErrorCodes["InsufficientStock"] = "INSUFFICIENT_STOCK";
    ICheckoutUserInputErrorCodes["Undefined"] = "UNDEFINED";
})(ICheckoutUserInputErrorCodes || (ICheckoutUserInputErrorCodes = {}));
export var IClearCartErrorType;
(function (IClearCartErrorType) {
    IClearCartErrorType["NotFound"] = "NOT_FOUND";
    IClearCartErrorType["Unauthorised"] = "UNAUTHORISED";
    IClearCartErrorType["Inactive"] = "INACTIVE";
    IClearCartErrorType["Undefined"] = "UNDEFINED";
})(IClearCartErrorType || (IClearCartErrorType = {}));
/** List of account confirmation statuses. */
export var IConfirmationStatusEnum;
(function (IConfirmationStatusEnum) {
    /** Account confirmed */
    IConfirmationStatusEnum["AccountConfirmed"] = "ACCOUNT_CONFIRMED";
    /** Account confirmation not required */
    IConfirmationStatusEnum["AccountConfirmationNotRequired"] = "ACCOUNT_CONFIRMATION_NOT_REQUIRED";
})(IConfirmationStatusEnum || (IConfirmationStatusEnum = {}));
/** The list of country codes. */
export var ICountryCodeEnum;
(function (ICountryCodeEnum) {
    /** Afghanistan */
    ICountryCodeEnum["Af"] = "AF";
    /** Åland Islands */
    ICountryCodeEnum["Ax"] = "AX";
    /** Albania */
    ICountryCodeEnum["Al"] = "AL";
    /** Algeria */
    ICountryCodeEnum["Dz"] = "DZ";
    /** American Samoa */
    ICountryCodeEnum["As"] = "AS";
    /** Andorra */
    ICountryCodeEnum["Ad"] = "AD";
    /** Angola */
    ICountryCodeEnum["Ao"] = "AO";
    /** Anguilla */
    ICountryCodeEnum["Ai"] = "AI";
    /** Antarctica */
    ICountryCodeEnum["Aq"] = "AQ";
    /** Antigua & Barbuda */
    ICountryCodeEnum["Ag"] = "AG";
    /** Argentina */
    ICountryCodeEnum["Ar"] = "AR";
    /** Armenia */
    ICountryCodeEnum["Am"] = "AM";
    /** Aruba */
    ICountryCodeEnum["Aw"] = "AW";
    /** Australia */
    ICountryCodeEnum["Au"] = "AU";
    /** Austria */
    ICountryCodeEnum["At"] = "AT";
    /** Azerbaijan */
    ICountryCodeEnum["Az"] = "AZ";
    /** Bahamas */
    ICountryCodeEnum["Bs"] = "BS";
    /** Bahrain */
    ICountryCodeEnum["Bh"] = "BH";
    /** Bangladesh */
    ICountryCodeEnum["Bd"] = "BD";
    /** Barbados */
    ICountryCodeEnum["Bb"] = "BB";
    /** Belarus */
    ICountryCodeEnum["By"] = "BY";
    /** Belgium */
    ICountryCodeEnum["Be"] = "BE";
    /** Belize */
    ICountryCodeEnum["Bz"] = "BZ";
    /** Benin */
    ICountryCodeEnum["Bj"] = "BJ";
    /** Bermuda */
    ICountryCodeEnum["Bm"] = "BM";
    /** Bhutan */
    ICountryCodeEnum["Bt"] = "BT";
    /** Bolivia */
    ICountryCodeEnum["Bo"] = "BO";
    /** Bosnia & Herzegovina */
    ICountryCodeEnum["Ba"] = "BA";
    /** Botswana */
    ICountryCodeEnum["Bw"] = "BW";
    /** Bouvet Island */
    ICountryCodeEnum["Bv"] = "BV";
    /** Brazil */
    ICountryCodeEnum["Br"] = "BR";
    /** British Indian Ocean Territory */
    ICountryCodeEnum["Io"] = "IO";
    /** British Virgin Islands */
    ICountryCodeEnum["Vg"] = "VG";
    /** Brunei */
    ICountryCodeEnum["Bn"] = "BN";
    /** Bulgaria */
    ICountryCodeEnum["Bg"] = "BG";
    /** Burkina Faso */
    ICountryCodeEnum["Bf"] = "BF";
    /** Burundi */
    ICountryCodeEnum["Bi"] = "BI";
    /** Cambodia */
    ICountryCodeEnum["Kh"] = "KH";
    /** Cameroon */
    ICountryCodeEnum["Cm"] = "CM";
    /** Canada */
    ICountryCodeEnum["Ca"] = "CA";
    /** Cape Verde */
    ICountryCodeEnum["Cv"] = "CV";
    /** Cayman Islands */
    ICountryCodeEnum["Ky"] = "KY";
    /** Central African Republic */
    ICountryCodeEnum["Cf"] = "CF";
    /** Chad */
    ICountryCodeEnum["Td"] = "TD";
    /** Chile */
    ICountryCodeEnum["Cl"] = "CL";
    /** China */
    ICountryCodeEnum["Cn"] = "CN";
    /** Christmas Island */
    ICountryCodeEnum["Cx"] = "CX";
    /** Cocos (Keeling) Islands */
    ICountryCodeEnum["Cc"] = "CC";
    /** Colombia */
    ICountryCodeEnum["Co"] = "CO";
    /** Comoros */
    ICountryCodeEnum["Km"] = "KM";
    /** Congo-Brazzaville */
    ICountryCodeEnum["Cg"] = "CG";
    /** Congo-Kinshasa */
    ICountryCodeEnum["Cd"] = "CD";
    /** Cook Islands */
    ICountryCodeEnum["Ck"] = "CK";
    /** Costa Rica */
    ICountryCodeEnum["Cr"] = "CR";
    /** Côte d’Ivoire */
    ICountryCodeEnum["Ci"] = "CI";
    /** Croatia */
    ICountryCodeEnum["Hr"] = "HR";
    /** Cuba */
    ICountryCodeEnum["Cu"] = "CU";
    /** Cyprus */
    ICountryCodeEnum["Cy"] = "CY";
    /** Czech Republic */
    ICountryCodeEnum["Cz"] = "CZ";
    /** Denmark */
    ICountryCodeEnum["Dk"] = "DK";
    /** Djibouti */
    ICountryCodeEnum["Dj"] = "DJ";
    /** Dominica */
    ICountryCodeEnum["Dm"] = "DM";
    /** Dominican Republic */
    ICountryCodeEnum["Do"] = "DO";
    /** Ecuador */
    ICountryCodeEnum["Ec"] = "EC";
    /** Egypt */
    ICountryCodeEnum["Eg"] = "EG";
    /** El Salvador */
    ICountryCodeEnum["Sv"] = "SV";
    /** Equatorial Guinea */
    ICountryCodeEnum["Gq"] = "GQ";
    /** Eritrea */
    ICountryCodeEnum["Er"] = "ER";
    /** Estonia */
    ICountryCodeEnum["Ee"] = "EE";
    /** Eswatini */
    ICountryCodeEnum["Sz"] = "SZ";
    /** Ethiopia */
    ICountryCodeEnum["Et"] = "ET";
    /** Falkland Islands */
    ICountryCodeEnum["Fk"] = "FK";
    /** Faroe Islands */
    ICountryCodeEnum["Fo"] = "FO";
    /** Fiji */
    ICountryCodeEnum["Fj"] = "FJ";
    /** Finland */
    ICountryCodeEnum["Fi"] = "FI";
    /** France */
    ICountryCodeEnum["Fr"] = "FR";
    /** French Guiana */
    ICountryCodeEnum["Gf"] = "GF";
    /** French Polynesia */
    ICountryCodeEnum["Pf"] = "PF";
    /** French Southern Territories */
    ICountryCodeEnum["Tf"] = "TF";
    /** Gabon */
    ICountryCodeEnum["Ga"] = "GA";
    /** Gambia */
    ICountryCodeEnum["Gm"] = "GM";
    /** Georgia */
    ICountryCodeEnum["Ge"] = "GE";
    /** Germany */
    ICountryCodeEnum["De"] = "DE";
    /** Ghana */
    ICountryCodeEnum["Gh"] = "GH";
    /** Gibraltar */
    ICountryCodeEnum["Gi"] = "GI";
    /** Greece */
    ICountryCodeEnum["Gr"] = "GR";
    /** Greenland */
    ICountryCodeEnum["Gl"] = "GL";
    /** Grenada */
    ICountryCodeEnum["Gd"] = "GD";
    /** Guadeloupe */
    ICountryCodeEnum["Gp"] = "GP";
    /** Guam */
    ICountryCodeEnum["Gu"] = "GU";
    /** Guatemala */
    ICountryCodeEnum["Gt"] = "GT";
    /** Guernsey */
    ICountryCodeEnum["Gg"] = "GG";
    /** Guinea */
    ICountryCodeEnum["Gn"] = "GN";
    /** Guinea-Bissau */
    ICountryCodeEnum["Gw"] = "GW";
    /** Guyana */
    ICountryCodeEnum["Gy"] = "GY";
    /** Haiti */
    ICountryCodeEnum["Ht"] = "HT";
    /** Heard &amp; McDonald Islands */
    ICountryCodeEnum["Hm"] = "HM";
    /** Honduras */
    ICountryCodeEnum["Hn"] = "HN";
    /** Hong Kong SAR China */
    ICountryCodeEnum["Hk"] = "HK";
    /** Hungary */
    ICountryCodeEnum["Hu"] = "HU";
    /** Iceland */
    ICountryCodeEnum["Is"] = "IS";
    /** India */
    ICountryCodeEnum["In"] = "IN";
    /** Indonesia */
    ICountryCodeEnum["Id"] = "ID";
    /** Iran */
    ICountryCodeEnum["Ir"] = "IR";
    /** Iraq */
    ICountryCodeEnum["Iq"] = "IQ";
    /** Ireland */
    ICountryCodeEnum["Ie"] = "IE";
    /** Isle of Man */
    ICountryCodeEnum["Im"] = "IM";
    /** Israel */
    ICountryCodeEnum["Il"] = "IL";
    /** Italy */
    ICountryCodeEnum["It"] = "IT";
    /** Jamaica */
    ICountryCodeEnum["Jm"] = "JM";
    /** Japan */
    ICountryCodeEnum["Jp"] = "JP";
    /** Jersey */
    ICountryCodeEnum["Je"] = "JE";
    /** Jordan */
    ICountryCodeEnum["Jo"] = "JO";
    /** Kazakhstan */
    ICountryCodeEnum["Kz"] = "KZ";
    /** Kenya */
    ICountryCodeEnum["Ke"] = "KE";
    /** Kiribati */
    ICountryCodeEnum["Ki"] = "KI";
    /** Kuwait */
    ICountryCodeEnum["Kw"] = "KW";
    /** Kyrgyzstan */
    ICountryCodeEnum["Kg"] = "KG";
    /** Laos */
    ICountryCodeEnum["La"] = "LA";
    /** Latvia */
    ICountryCodeEnum["Lv"] = "LV";
    /** Lebanon */
    ICountryCodeEnum["Lb"] = "LB";
    /** Lesotho */
    ICountryCodeEnum["Ls"] = "LS";
    /** Liberia */
    ICountryCodeEnum["Lr"] = "LR";
    /** Libya */
    ICountryCodeEnum["Ly"] = "LY";
    /** Liechtenstein */
    ICountryCodeEnum["Li"] = "LI";
    /** Lithuania */
    ICountryCodeEnum["Lt"] = "LT";
    /** Luxembourg */
    ICountryCodeEnum["Lu"] = "LU";
    /** Macau SAR China */
    ICountryCodeEnum["Mo"] = "MO";
    /** Macedonia */
    ICountryCodeEnum["Mk"] = "MK";
    /** Madagascar */
    ICountryCodeEnum["Mg"] = "MG";
    /** Malawi */
    ICountryCodeEnum["Mw"] = "MW";
    /** Malaysia */
    ICountryCodeEnum["My"] = "MY";
    /** Maldives */
    ICountryCodeEnum["Mv"] = "MV";
    /** Mali */
    ICountryCodeEnum["Ml"] = "ML";
    /** Malta */
    ICountryCodeEnum["Mt"] = "MT";
    /** Marshall Islands */
    ICountryCodeEnum["Mh"] = "MH";
    /** Martinique */
    ICountryCodeEnum["Mq"] = "MQ";
    /** Mauritania */
    ICountryCodeEnum["Mr"] = "MR";
    /** Mauritius */
    ICountryCodeEnum["Mu"] = "MU";
    /** Mayotte */
    ICountryCodeEnum["Yt"] = "YT";
    /** Mexico */
    ICountryCodeEnum["Mx"] = "MX";
    /** Micronesia */
    ICountryCodeEnum["Fm"] = "FM";
    /** Moldova */
    ICountryCodeEnum["Md"] = "MD";
    /** Monaco */
    ICountryCodeEnum["Mc"] = "MC";
    /** Mongolia */
    ICountryCodeEnum["Mn"] = "MN";
    /** Montenegro */
    ICountryCodeEnum["Me"] = "ME";
    /** Montserrat */
    ICountryCodeEnum["Ms"] = "MS";
    /** Morocco */
    ICountryCodeEnum["Ma"] = "MA";
    /** Mozambique */
    ICountryCodeEnum["Mz"] = "MZ";
    /** Myanmar (Burma) */
    ICountryCodeEnum["Mm"] = "MM";
    /** Namibia */
    ICountryCodeEnum["Na"] = "NA";
    /** Nauru */
    ICountryCodeEnum["Nr"] = "NR";
    /** Nepal */
    ICountryCodeEnum["Np"] = "NP";
    /** Netherlands */
    ICountryCodeEnum["Nl"] = "NL";
    /** Netherlands Antilles */
    ICountryCodeEnum["An"] = "AN";
    /** New Caledonia */
    ICountryCodeEnum["Nc"] = "NC";
    /** New Zealand */
    ICountryCodeEnum["Nz"] = "NZ";
    /** Nicaragua */
    ICountryCodeEnum["Ni"] = "NI";
    /** Niger */
    ICountryCodeEnum["Ne"] = "NE";
    /** Nigeria */
    ICountryCodeEnum["Ng"] = "NG";
    /** Niue */
    ICountryCodeEnum["Nu"] = "NU";
    /** Norfolk Island */
    ICountryCodeEnum["Nf"] = "NF";
    /** Northern Mariana Islands */
    ICountryCodeEnum["Mp"] = "MP";
    /** North Korea */
    ICountryCodeEnum["Kp"] = "KP";
    /** Norway */
    ICountryCodeEnum["No"] = "NO";
    /** Oman */
    ICountryCodeEnum["Om"] = "OM";
    /** Pakistan */
    ICountryCodeEnum["Pk"] = "PK";
    /** Palau */
    ICountryCodeEnum["Pw"] = "PW";
    /** Palestinian Territories */
    ICountryCodeEnum["Ps"] = "PS";
    /** Panama */
    ICountryCodeEnum["Pa"] = "PA";
    /** Papua New Guinea */
    ICountryCodeEnum["Pg"] = "PG";
    /** Paraguay */
    ICountryCodeEnum["Py"] = "PY";
    /** Peru */
    ICountryCodeEnum["Pe"] = "PE";
    /** Philippines */
    ICountryCodeEnum["Ph"] = "PH";
    /** Pitcairn Islands */
    ICountryCodeEnum["Pn"] = "PN";
    /** Poland */
    ICountryCodeEnum["Pl"] = "PL";
    /** Portugal */
    ICountryCodeEnum["Pt"] = "PT";
    /** Qatar */
    ICountryCodeEnum["Qa"] = "QA";
    /** Réunion */
    ICountryCodeEnum["Re"] = "RE";
    /** Romania */
    ICountryCodeEnum["Ro"] = "RO";
    /** Russia */
    ICountryCodeEnum["Ru"] = "RU";
    /** Rwanda */
    ICountryCodeEnum["Rw"] = "RW";
    /** Samoa */
    ICountryCodeEnum["Ws"] = "WS";
    /** San Marino */
    ICountryCodeEnum["Sm"] = "SM";
    /** São Tomé & Príncipe */
    ICountryCodeEnum["St"] = "ST";
    /** Saudi Arabia */
    ICountryCodeEnum["Sa"] = "SA";
    /** Senegal */
    ICountryCodeEnum["Sn"] = "SN";
    /** Serbia */
    ICountryCodeEnum["Rs"] = "RS";
    /** Seychelles */
    ICountryCodeEnum["Sc"] = "SC";
    /** Sierra Leone */
    ICountryCodeEnum["Sl"] = "SL";
    /** Singapore */
    ICountryCodeEnum["Sg"] = "SG";
    /** Slovakia */
    ICountryCodeEnum["Sk"] = "SK";
    /** Slovenia */
    ICountryCodeEnum["Si"] = "SI";
    /** Solomon Islands */
    ICountryCodeEnum["Sb"] = "SB";
    /** Somalia */
    ICountryCodeEnum["So"] = "SO";
    /** South Africa */
    ICountryCodeEnum["Za"] = "ZA";
    /** South Georgia & South Sandwich Islands */
    ICountryCodeEnum["Gs"] = "GS";
    /** South Korea */
    ICountryCodeEnum["Kr"] = "KR";
    /** Spain */
    ICountryCodeEnum["Es"] = "ES";
    /** Sri Lanka */
    ICountryCodeEnum["Lk"] = "LK";
    /** St. Barthélemy */
    ICountryCodeEnum["Bl"] = "BL";
    /** St. Helena */
    ICountryCodeEnum["Sh"] = "SH";
    /** St. Kitts & Nevis */
    ICountryCodeEnum["Kn"] = "KN";
    /** St. Lucia */
    ICountryCodeEnum["Lc"] = "LC";
    /** St. Martin */
    ICountryCodeEnum["Mf"] = "MF";
    /** St. Pierre & Miquelon */
    ICountryCodeEnum["Pm"] = "PM";
    /** St. Vincent & Grenadines */
    ICountryCodeEnum["Vc"] = "VC";
    /** Sudan */
    ICountryCodeEnum["Sd"] = "SD";
    /** Suriname */
    ICountryCodeEnum["Sr"] = "SR";
    /** Svalbard & Jan Mayen */
    ICountryCodeEnum["Sj"] = "SJ";
    /** Sweden */
    ICountryCodeEnum["Se"] = "SE";
    /** Switzerland */
    ICountryCodeEnum["Ch"] = "CH";
    /** Syria */
    ICountryCodeEnum["Sy"] = "SY";
    /** Taiwan */
    ICountryCodeEnum["Tw"] = "TW";
    /** Tajikistan */
    ICountryCodeEnum["Tj"] = "TJ";
    /** Tanzania */
    ICountryCodeEnum["Tz"] = "TZ";
    /** Thailand */
    ICountryCodeEnum["Th"] = "TH";
    /** Timor-Leste */
    ICountryCodeEnum["Tl"] = "TL";
    /** Togo */
    ICountryCodeEnum["Tg"] = "TG";
    /** Tokelau */
    ICountryCodeEnum["Tk"] = "TK";
    /** Tonga */
    ICountryCodeEnum["To"] = "TO";
    /** Trinidad & Tobago */
    ICountryCodeEnum["Tt"] = "TT";
    /** Tunisia */
    ICountryCodeEnum["Tn"] = "TN";
    /** Turkey */
    ICountryCodeEnum["Tr"] = "TR";
    /** Turkmenistan */
    ICountryCodeEnum["Tm"] = "TM";
    /** Turks & Caicos Islands */
    ICountryCodeEnum["Tc"] = "TC";
    /** Tuvalu */
    ICountryCodeEnum["Tv"] = "TV";
    /** Uganda */
    ICountryCodeEnum["Ug"] = "UG";
    /** Ukraine */
    ICountryCodeEnum["Ua"] = "UA";
    /** United Arab Emirates */
    ICountryCodeEnum["Ae"] = "AE";
    /** United Kingdom */
    ICountryCodeEnum["Gb"] = "GB";
    /** United States */
    ICountryCodeEnum["Us"] = "US";
    /** Uruguay */
    ICountryCodeEnum["Uy"] = "UY";
    /** U.S. Outlying Islands */
    ICountryCodeEnum["Um"] = "UM";
    /** U.S. Virgin Islands */
    ICountryCodeEnum["Vi"] = "VI";
    /** Uzbekistan */
    ICountryCodeEnum["Uz"] = "UZ";
    /** Vanuatu */
    ICountryCodeEnum["Vu"] = "VU";
    /** Vatican City */
    ICountryCodeEnum["Va"] = "VA";
    /** Venezuela */
    ICountryCodeEnum["Ve"] = "VE";
    /** Vietnam */
    ICountryCodeEnum["Vn"] = "VN";
    /** Wallis & Futuna */
    ICountryCodeEnum["Wf"] = "WF";
    /** Western Sahara */
    ICountryCodeEnum["Eh"] = "EH";
    /** Yemen */
    ICountryCodeEnum["Ye"] = "YE";
    /** Zambia */
    ICountryCodeEnum["Zm"] = "ZM";
    /** Zimbabwe */
    ICountryCodeEnum["Zw"] = "ZW";
})(ICountryCodeEnum || (ICountryCodeEnum = {}));
/** The list of available currency codes. */
export var ICurrencyEnum;
(function (ICurrencyEnum) {
    ICurrencyEnum["Afn"] = "AFN";
    ICurrencyEnum["All"] = "ALL";
    ICurrencyEnum["Azn"] = "AZN";
    ICurrencyEnum["Dzd"] = "DZD";
    ICurrencyEnum["Aoa"] = "AOA";
    ICurrencyEnum["Ars"] = "ARS";
    ICurrencyEnum["Amd"] = "AMD";
    ICurrencyEnum["Awg"] = "AWG";
    ICurrencyEnum["Aud"] = "AUD";
    ICurrencyEnum["Bsd"] = "BSD";
    ICurrencyEnum["Bhd"] = "BHD";
    ICurrencyEnum["Bdt"] = "BDT";
    ICurrencyEnum["Bbd"] = "BBD";
    ICurrencyEnum["Byn"] = "BYN";
    ICurrencyEnum["Bzd"] = "BZD";
    ICurrencyEnum["Bmd"] = "BMD";
    ICurrencyEnum["Btn"] = "BTN";
    ICurrencyEnum["Bob"] = "BOB";
    ICurrencyEnum["Bam"] = "BAM";
    ICurrencyEnum["Bwp"] = "BWP";
    ICurrencyEnum["Brl"] = "BRL";
    ICurrencyEnum["Gbp"] = "GBP";
    ICurrencyEnum["Bnd"] = "BND";
    ICurrencyEnum["Bgn"] = "BGN";
    ICurrencyEnum["Buk"] = "BUK";
    ICurrencyEnum["Bif"] = "BIF";
    ICurrencyEnum["Khr"] = "KHR";
    ICurrencyEnum["Cad"] = "CAD";
    ICurrencyEnum["Cve"] = "CVE";
    ICurrencyEnum["Czk"] = "CZK";
    ICurrencyEnum["Kyd"] = "KYD";
    ICurrencyEnum["Gqe"] = "GQE";
    ICurrencyEnum["Clp"] = "CLP";
    ICurrencyEnum["Cny"] = "CNY";
    ICurrencyEnum["Cop"] = "COP";
    ICurrencyEnum["Kmf"] = "KMF";
    ICurrencyEnum["Cdf"] = "CDF";
    ICurrencyEnum["Crc"] = "CRC";
    ICurrencyEnum["Hrk"] = "HRK";
    ICurrencyEnum["Cup"] = "CUP";
    ICurrencyEnum["Dkk"] = "DKK";
    ICurrencyEnum["Djf"] = "DJF";
    ICurrencyEnum["Dop"] = "DOP";
    ICurrencyEnum["Xcd"] = "XCD";
    ICurrencyEnum["Egp"] = "EGP";
    ICurrencyEnum["Svc"] = "SVC";
    ICurrencyEnum["Ern"] = "ERN";
    ICurrencyEnum["Eek"] = "EEK";
    ICurrencyEnum["Etb"] = "ETB";
    ICurrencyEnum["Eur"] = "EUR";
    ICurrencyEnum["Fkp"] = "FKP";
    ICurrencyEnum["Fjd"] = "FJD";
    ICurrencyEnum["Gmd"] = "GMD";
    ICurrencyEnum["Gek"] = "GEK";
    ICurrencyEnum["Gel"] = "GEL";
    ICurrencyEnum["Ghs"] = "GHS";
    ICurrencyEnum["Gip"] = "GIP";
    ICurrencyEnum["Gtq"] = "GTQ";
    ICurrencyEnum["Gnf"] = "GNF";
    ICurrencyEnum["Gyd"] = "GYD";
    ICurrencyEnum["Htg"] = "HTG";
    ICurrencyEnum["Hnl"] = "HNL";
    ICurrencyEnum["Hkd"] = "HKD";
    ICurrencyEnum["Huf"] = "HUF";
    ICurrencyEnum["Isk"] = "ISK";
    ICurrencyEnum["Inr"] = "INR";
    ICurrencyEnum["Idr"] = "IDR";
    ICurrencyEnum["Irr"] = "IRR";
    ICurrencyEnum["Iqd"] = "IQD";
    ICurrencyEnum["Ils"] = "ILS";
    ICurrencyEnum["Jmd"] = "JMD";
    ICurrencyEnum["Jpy"] = "JPY";
    ICurrencyEnum["Jod"] = "JOD";
    ICurrencyEnum["Kzt"] = "KZT";
    ICurrencyEnum["Kes"] = "KES";
    ICurrencyEnum["Kwd"] = "KWD";
    ICurrencyEnum["Kgs"] = "KGS";
    ICurrencyEnum["Lak"] = "LAK";
    ICurrencyEnum["Lvl"] = "LVL";
    ICurrencyEnum["Lbp"] = "LBP";
    ICurrencyEnum["Lsl"] = "LSL";
    ICurrencyEnum["Lrd"] = "LRD";
    ICurrencyEnum["Lyd"] = "LYD";
    ICurrencyEnum["Ltl"] = "LTL";
    ICurrencyEnum["Mop"] = "MOP";
    ICurrencyEnum["Mkd"] = "MKD";
    ICurrencyEnum["Mga"] = "MGA";
    ICurrencyEnum["Mwk"] = "MWK";
    ICurrencyEnum["Myr"] = "MYR";
    ICurrencyEnum["Mvr"] = "MVR";
    ICurrencyEnum["Lsm"] = "LSM";
    ICurrencyEnum["Mro"] = "MRO";
    ICurrencyEnum["Mur"] = "MUR";
    ICurrencyEnum["Mxn"] = "MXN";
    ICurrencyEnum["Mdl"] = "MDL";
    ICurrencyEnum["Mnt"] = "MNT";
    ICurrencyEnum["Mad"] = "MAD";
    ICurrencyEnum["Mzn"] = "MZN";
    ICurrencyEnum["Mmk"] = "MMK";
    ICurrencyEnum["Nad"] = "NAD";
    ICurrencyEnum["Npr"] = "NPR";
    ICurrencyEnum["Ang"] = "ANG";
    ICurrencyEnum["Ytl"] = "YTL";
    ICurrencyEnum["Nzd"] = "NZD";
    ICurrencyEnum["Nic"] = "NIC";
    ICurrencyEnum["Ngn"] = "NGN";
    ICurrencyEnum["Kpw"] = "KPW";
    ICurrencyEnum["Nok"] = "NOK";
    ICurrencyEnum["Omr"] = "OMR";
    ICurrencyEnum["Pkr"] = "PKR";
    ICurrencyEnum["Pab"] = "PAB";
    ICurrencyEnum["Pgk"] = "PGK";
    ICurrencyEnum["Pyg"] = "PYG";
    ICurrencyEnum["Pen"] = "PEN";
    ICurrencyEnum["Php"] = "PHP";
    ICurrencyEnum["Pln"] = "PLN";
    ICurrencyEnum["Qar"] = "QAR";
    ICurrencyEnum["Rhd"] = "RHD";
    ICurrencyEnum["Ron"] = "RON";
    ICurrencyEnum["Rub"] = "RUB";
    ICurrencyEnum["Rwf"] = "RWF";
    ICurrencyEnum["Shp"] = "SHP";
    ICurrencyEnum["Std"] = "STD";
    ICurrencyEnum["Sar"] = "SAR";
    ICurrencyEnum["Rsd"] = "RSD";
    ICurrencyEnum["Scr"] = "SCR";
    ICurrencyEnum["Sll"] = "SLL";
    ICurrencyEnum["Sgd"] = "SGD";
    ICurrencyEnum["Skk"] = "SKK";
    ICurrencyEnum["Sbd"] = "SBD";
    ICurrencyEnum["Sos"] = "SOS";
    ICurrencyEnum["Zar"] = "ZAR";
    ICurrencyEnum["Krw"] = "KRW";
    ICurrencyEnum["Lkr"] = "LKR";
    ICurrencyEnum["Sdg"] = "SDG";
    ICurrencyEnum["Srd"] = "SRD";
    ICurrencyEnum["Szl"] = "SZL";
    ICurrencyEnum["Sek"] = "SEK";
    ICurrencyEnum["Chf"] = "CHF";
    ICurrencyEnum["Syp"] = "SYP";
    ICurrencyEnum["Twd"] = "TWD";
    ICurrencyEnum["Tjs"] = "TJS";
    ICurrencyEnum["Tzs"] = "TZS";
    ICurrencyEnum["Thb"] = "THB";
    ICurrencyEnum["Top"] = "TOP";
    ICurrencyEnum["Ttd"] = "TTD";
    ICurrencyEnum["Tnd"] = "TND";
    ICurrencyEnum["Tmm"] = "TMM";
    ICurrencyEnum["Usd"] = "USD";
    ICurrencyEnum["Ugx"] = "UGX";
    ICurrencyEnum["Uah"] = "UAH";
    ICurrencyEnum["Aed"] = "AED";
    ICurrencyEnum["Uyu"] = "UYU";
    ICurrencyEnum["Uzs"] = "UZS";
    ICurrencyEnum["Vuv"] = "VUV";
    ICurrencyEnum["Veb"] = "VEB";
    ICurrencyEnum["Vef"] = "VEF";
    ICurrencyEnum["Vnd"] = "VND";
    ICurrencyEnum["Che"] = "CHE";
    ICurrencyEnum["Chw"] = "CHW";
    ICurrencyEnum["Xof"] = "XOF";
    ICurrencyEnum["Wst"] = "WST";
    ICurrencyEnum["Yer"] = "YER";
    ICurrencyEnum["Zmk"] = "ZMK";
    ICurrencyEnum["Zwd"] = "ZWD";
    ICurrencyEnum["Try"] = "TRY";
    ICurrencyEnum["Azm"] = "AZM";
    ICurrencyEnum["Rol"] = "ROL";
    ICurrencyEnum["Trl"] = "TRL";
    ICurrencyEnum["Xpf"] = "XPF";
})(ICurrencyEnum || (ICurrencyEnum = {}));
/** Specifies the field to use for sorting */
export var ICustomerOrderSortableField;
(function (ICustomerOrderSortableField) {
    /** Sorts customer orders by number */
    ICustomerOrderSortableField["Number"] = "NUMBER";
    /** Sorts customer orders by created_at field */
    ICustomerOrderSortableField["CreatedAt"] = "CREATED_AT";
})(ICustomerOrderSortableField || (ICustomerOrderSortableField = {}));
/** Defines the customizable date type. */
export var ICustomizableDateTypeEnum;
(function (ICustomizableDateTypeEnum) {
    ICustomizableDateTypeEnum["Date"] = "DATE";
    ICustomizableDateTypeEnum["DateTime"] = "DATE_TIME";
    ICustomizableDateTypeEnum["Time"] = "TIME";
})(ICustomizableDateTypeEnum || (ICustomizableDateTypeEnum = {}));
export var IDownloadableFileTypeEnum;
(function (IDownloadableFileTypeEnum) {
    IDownloadableFileTypeEnum["File"] = "FILE";
    IDownloadableFileTypeEnum["Url"] = "URL";
})(IDownloadableFileTypeEnum || (IDownloadableFileTypeEnum = {}));
/** Indicates the locations the dynamic block can be placed. If this field is not specified, the query returns all locations. */
export var IDynamicBlockLocationEnum;
(function (IDynamicBlockLocationEnum) {
    IDynamicBlockLocationEnum["Content"] = "CONTENT";
    IDynamicBlockLocationEnum["Header"] = "HEADER";
    IDynamicBlockLocationEnum["Footer"] = "FOOTER";
    IDynamicBlockLocationEnum["Left"] = "LEFT";
    IDynamicBlockLocationEnum["Right"] = "RIGHT";
})(IDynamicBlockLocationEnum || (IDynamicBlockLocationEnum = {}));
/** Indicates the selected Dynamic Blocks Rotator inline widget. */
export var IDynamicBlockTypeEnum;
(function (IDynamicBlockTypeEnum) {
    IDynamicBlockTypeEnum["Specified"] = "SPECIFIED";
    IDynamicBlockTypeEnum["CartPriceRuleRelated"] = "CART_PRICE_RULE_RELATED";
    IDynamicBlockTypeEnum["CatalogPriceRuleRelated"] = "CATALOG_PRICE_RULE_RELATED";
})(IDynamicBlockTypeEnum || (IDynamicBlockTypeEnum = {}));
export var IFilterMatchTypeEnum;
(function (IFilterMatchTypeEnum) {
    IFilterMatchTypeEnum["Full"] = "FULL";
    IFilterMatchTypeEnum["Partial"] = "PARTIAL";
})(IFilterMatchTypeEnum || (IFilterMatchTypeEnum = {}));
/** Lists display settings for the Fixed Product Tax. */
export var IFixedProductTaxDisplaySettings;
(function (IFixedProductTaxDisplaySettings) {
    /** The displayed price includes the FPT amount without displaying the `ProductPrice.fixed_product_taxes` values. This value corresponds to 'Including FPT only'. */
    IFixedProductTaxDisplaySettings["IncludeFptWithoutDetails"] = "INCLUDE_FPT_WITHOUT_DETAILS";
    /** The displayed price includes the FPT amount while displaying the values of `ProductPrice.fixed_product_taxes` separately. This value corresponds to 'Including FPT and FPT description'. */
    IFixedProductTaxDisplaySettings["IncludeFptWithDetails"] = "INCLUDE_FPT_WITH_DETAILS";
    /** The displayed price does not include the FPT amount. The values of `ProductPrice.fixed_product_taxes` and the price including the FPT are displayed separately. This value corresponds to 'Excluding FPT, Including FPT description and final price.' */
    IFixedProductTaxDisplaySettings["ExcludeFptAndIncludeWithDetails"] = "EXCLUDE_FPT_AND_INCLUDE_WITH_DETAILS";
    /** The displayed price does not include the FPT amount. The values from `ProductPrice.fixed_product_taxes` are not displayed. This value corresponds to 'Excluding FPT'. */
    IFixedProductTaxDisplaySettings["ExcludeFptWithoutDetails"] = "EXCLUDE_FPT_WITHOUT_DETAILS";
    /** The FPT feature is not enabled. You can omit `ProductPrice.fixed_product_taxes` from your query. */
    IFixedProductTaxDisplaySettings["FptDisabled"] = "FPT_DISABLED";
})(IFixedProductTaxDisplaySettings || (IFixedProductTaxDisplaySettings = {}));
/** Specifies the gift card type. */
export var IGiftCardTypeEnum;
(function (IGiftCardTypeEnum) {
    IGiftCardTypeEnum["Virtual"] = "VIRTUAL";
    IGiftCardTypeEnum["Physical"] = "PHYSICAL";
    IGiftCardTypeEnum["Combined"] = "COMBINED";
})(IGiftCardTypeEnum || (IGiftCardTypeEnum = {}));
/** Defines the group type of a gift registry dynamic attribute. */
export var IGiftRegistryDynamicAttributeGroup;
(function (IGiftRegistryDynamicAttributeGroup) {
    IGiftRegistryDynamicAttributeGroup["EventInformation"] = "EVENT_INFORMATION";
    IGiftRegistryDynamicAttributeGroup["PrivacySettings"] = "PRIVACY_SETTINGS";
    IGiftRegistryDynamicAttributeGroup["Registrant"] = "REGISTRANT";
    IGiftRegistryDynamicAttributeGroup["GeneralInformation"] = "GENERAL_INFORMATION";
    IGiftRegistryDynamicAttributeGroup["DetailedInformation"] = "DETAILED_INFORMATION";
    IGiftRegistryDynamicAttributeGroup["ShippingAddress"] = "SHIPPING_ADDRESS";
})(IGiftRegistryDynamicAttributeGroup || (IGiftRegistryDynamicAttributeGroup = {}));
/** Defines the error type. */
export var IGiftRegistryItemsUserErrorType;
(function (IGiftRegistryItemsUserErrorType) {
    /** Used for handling out of stock products. */
    IGiftRegistryItemsUserErrorType["OutOfStock"] = "OUT_OF_STOCK";
    /** Used for exceptions like EntityNotFound. */
    IGiftRegistryItemsUserErrorType["NotFound"] = "NOT_FOUND";
    /** Used for other exceptions, such as database connection failures. */
    IGiftRegistryItemsUserErrorType["Undefined"] = "UNDEFINED";
})(IGiftRegistryItemsUserErrorType || (IGiftRegistryItemsUserErrorType = {}));
/** Defines the privacy setting of the gift registry. */
export var IGiftRegistryPrivacySettings;
(function (IGiftRegistryPrivacySettings) {
    IGiftRegistryPrivacySettings["Private"] = "PRIVATE";
    IGiftRegistryPrivacySettings["Public"] = "PUBLIC";
})(IGiftRegistryPrivacySettings || (IGiftRegistryPrivacySettings = {}));
/** Defines the status of the gift registry. */
export var IGiftRegistryStatus;
(function (IGiftRegistryStatus) {
    IGiftRegistryStatus["Active"] = "ACTIVE";
    IGiftRegistryStatus["Inactive"] = "INACTIVE";
})(IGiftRegistryStatus || (IGiftRegistryStatus = {}));
/** List of templates/filters applied to customer attribute input. */
export var IInputFilterEnum;
(function (IInputFilterEnum) {
    /** There are no templates or filters to be applied. */
    IInputFilterEnum["None"] = "NONE";
    /** Forces attribute input to follow the date format. */
    IInputFilterEnum["Date"] = "DATE";
    /** Strip whitespace (or other characters) from the beginning and end of the input. */
    IInputFilterEnum["Trim"] = "TRIM";
    /** Strip HTML Tags. */
    IInputFilterEnum["Striptags"] = "STRIPTAGS";
    /** Escape HTML Entities. */
    IInputFilterEnum["Escapehtml"] = "ESCAPEHTML";
})(IInputFilterEnum || (IInputFilterEnum = {}));
export var IOrderDataTypeEnum;
(function (IOrderDataTypeEnum) {
    IOrderDataTypeEnum["Text"] = "text";
    IOrderDataTypeEnum["Int"] = "int";
})(IOrderDataTypeEnum || (IOrderDataTypeEnum = {}));
export var IOrderInputTypeEnum;
(function (IOrderInputTypeEnum) {
    IOrderInputTypeEnum["Text"] = "text";
    IOrderInputTypeEnum["Multiselect"] = "multiselect";
    IOrderInputTypeEnum["Select"] = "select";
    IOrderInputTypeEnum["Radio"] = "radio";
    IOrderInputTypeEnum["Textarea"] = "textarea";
    IOrderInputTypeEnum["Checkbox"] = "checkbox";
})(IOrderInputTypeEnum || (IOrderInputTypeEnum = {}));
export var IOrderTypeEnum;
(function (IOrderTypeEnum) {
    IOrderTypeEnum["Trial"] = "TRIAL";
    IOrderTypeEnum["Regular"] = "REGULAR";
})(IOrderTypeEnum || (IOrderTypeEnum = {}));
/** Indicates the mode for payment. Applies to the Payflow Link and Payments Advanced payment methods. */
export var IPayflowLinkMode;
(function (IPayflowLinkMode) {
    IPayflowLinkMode["Test"] = "TEST";
    IPayflowLinkMode["Live"] = "LIVE";
})(IPayflowLinkMode || (IPayflowLinkMode = {}));
/** Defines the origin location for that payment request */
export var IPaymentLocation;
(function (IPaymentLocation) {
    IPaymentLocation["ProductDetail"] = "PRODUCT_DETAIL";
    IPaymentLocation["Minicart"] = "MINICART";
    IPaymentLocation["Cart"] = "CART";
    IPaymentLocation["Checkout"] = "CHECKOUT";
    IPaymentLocation["Admin"] = "ADMIN";
})(IPaymentLocation || (IPaymentLocation = {}));
/** The list of available payment token types. */
export var IPaymentTokenTypeEnum;
(function (IPaymentTokenTypeEnum) {
    /** phpcs:ignore Magento2.GraphQL.ValidArgumentName */
    IPaymentTokenTypeEnum["Card"] = "card";
    /** phpcs:ignore Magento2.GraphQL.ValidArgumentName */
    IPaymentTokenTypeEnum["Account"] = "account";
})(IPaymentTokenTypeEnum || (IPaymentTokenTypeEnum = {}));
export var IPlaceOrderErrorCodes;
(function (IPlaceOrderErrorCodes) {
    IPlaceOrderErrorCodes["CartNotFound"] = "CART_NOT_FOUND";
    IPlaceOrderErrorCodes["CartNotActive"] = "CART_NOT_ACTIVE";
    IPlaceOrderErrorCodes["GuestEmailMissing"] = "GUEST_EMAIL_MISSING";
    IPlaceOrderErrorCodes["UnableToPlaceOrder"] = "UNABLE_TO_PLACE_ORDER";
    IPlaceOrderErrorCodes["Undefined"] = "UNDEFINED";
})(IPlaceOrderErrorCodes || (IPlaceOrderErrorCodes = {}));
/** `PriceAdjustment.code` is deprecated. */
export var IPriceAdjustmentCodesEnum;
(function (IPriceAdjustmentCodesEnum) {
    IPriceAdjustmentCodesEnum["Tax"] = "TAX";
    IPriceAdjustmentCodesEnum["Weee"] = "WEEE";
    IPriceAdjustmentCodesEnum["WeeeTax"] = "WEEE_TAX";
})(IPriceAdjustmentCodesEnum || (IPriceAdjustmentCodesEnum = {}));
/** `PriceAdjustmentDescriptionEnum` is deprecated. States whether a price adjustment is included or excluded. */
export var IPriceAdjustmentDescriptionEnum;
(function (IPriceAdjustmentDescriptionEnum) {
    IPriceAdjustmentDescriptionEnum["Included"] = "INCLUDED";
    IPriceAdjustmentDescriptionEnum["Excluded"] = "EXCLUDED";
})(IPriceAdjustmentDescriptionEnum || (IPriceAdjustmentDescriptionEnum = {}));
/** Defines the price type. */
export var IPriceTypeEnum;
(function (IPriceTypeEnum) {
    IPriceTypeEnum["Fixed"] = "FIXED";
    IPriceTypeEnum["Percent"] = "PERCENT";
    IPriceTypeEnum["Dynamic"] = "DYNAMIC";
    IPriceTypeEnum["Presentation"] = "PRESENTATION";
})(IPriceTypeEnum || (IPriceTypeEnum = {}));
/** Defines whether a bundle product's price is displayed as the lowest possible value or as a range. */
export var IPriceViewEnum;
(function (IPriceViewEnum) {
    IPriceViewEnum["PriceRange"] = "PRICE_RANGE";
    IPriceViewEnum["AsLowAs"] = "AS_LOW_AS";
})(IPriceViewEnum || (IPriceViewEnum = {}));
/** This enumeration states whether a product stock status is in stock or out of stock */
export var IProductStockStatus;
(function (IProductStockStatus) {
    IProductStockStatus["InStock"] = "IN_STOCK";
    IProductStockStatus["OutOfStock"] = "OUT_OF_STOCK";
})(IProductStockStatus || (IProductStockStatus = {}));
export var IReCaptchaFormEnum;
(function (IReCaptchaFormEnum) {
    IReCaptchaFormEnum["PlaceOrder"] = "PLACE_ORDER";
    IReCaptchaFormEnum["Contact"] = "CONTACT";
    IReCaptchaFormEnum["CustomerLogin"] = "CUSTOMER_LOGIN";
    IReCaptchaFormEnum["CustomerForgotPassword"] = "CUSTOMER_FORGOT_PASSWORD";
    IReCaptchaFormEnum["CustomerCreate"] = "CUSTOMER_CREATE";
    IReCaptchaFormEnum["CustomerEdit"] = "CUSTOMER_EDIT";
    IReCaptchaFormEnum["Newsletter"] = "NEWSLETTER";
    IReCaptchaFormEnum["ProductReview"] = "PRODUCT_REVIEW";
    IReCaptchaFormEnum["Sendfriend"] = "SENDFRIEND";
    IReCaptchaFormEnum["Braintree"] = "BRAINTREE";
})(IReCaptchaFormEnum || (IReCaptchaFormEnum = {}));
export var IReturnItemStatus;
(function (IReturnItemStatus) {
    IReturnItemStatus["Pending"] = "PENDING";
    IReturnItemStatus["Authorized"] = "AUTHORIZED";
    IReturnItemStatus["Received"] = "RECEIVED";
    IReturnItemStatus["Approved"] = "APPROVED";
    IReturnItemStatus["Rejected"] = "REJECTED";
    IReturnItemStatus["Denied"] = "DENIED";
})(IReturnItemStatus || (IReturnItemStatus = {}));
export var IReturnShippingTrackingStatusType;
(function (IReturnShippingTrackingStatusType) {
    IReturnShippingTrackingStatusType["Information"] = "INFORMATION";
    IReturnShippingTrackingStatusType["Error"] = "ERROR";
})(IReturnShippingTrackingStatusType || (IReturnShippingTrackingStatusType = {}));
export var IReturnStatus;
(function (IReturnStatus) {
    IReturnStatus["Pending"] = "PENDING";
    IReturnStatus["Authorized"] = "AUTHORIZED";
    IReturnStatus["PartiallyAuthorized"] = "PARTIALLY_AUTHORIZED";
    IReturnStatus["Received"] = "RECEIVED";
    IReturnStatus["PartiallyReceived"] = "PARTIALLY_RECEIVED";
    IReturnStatus["Approved"] = "APPROVED";
    IReturnStatus["PartiallyApproved"] = "PARTIALLY_APPROVED";
    IReturnStatus["Rejected"] = "REJECTED";
    IReturnStatus["PartiallyRejected"] = "PARTIALLY_REJECTED";
    IReturnStatus["Denied"] = "DENIED";
    IReturnStatus["ProcessedAndClosed"] = "PROCESSED_AND_CLOSED";
    IReturnStatus["Closed"] = "CLOSED";
})(IReturnStatus || (IReturnStatus = {}));
export var IRewardPointsSubscriptionStatusesEnum;
(function (IRewardPointsSubscriptionStatusesEnum) {
    IRewardPointsSubscriptionStatusesEnum["Subscribed"] = "SUBSCRIBED";
    IRewardPointsSubscriptionStatusesEnum["NotSubscribed"] = "NOT_SUBSCRIBED";
})(IRewardPointsSubscriptionStatusesEnum || (IRewardPointsSubscriptionStatusesEnum = {}));
/** This enumeration defines the scope type for customer orders. */
export var IScopeTypeEnum;
(function (IScopeTypeEnum) {
    IScopeTypeEnum["Global"] = "GLOBAL";
    IScopeTypeEnum["Website"] = "WEBSITE";
    IScopeTypeEnum["Store"] = "STORE";
})(IScopeTypeEnum || (IScopeTypeEnum = {}));
/** Defines whether bundle items must be shipped together. */
export var IShipBundleItemsEnum;
(function (IShipBundleItemsEnum) {
    IShipBundleItemsEnum["Together"] = "TOGETHER";
    IShipBundleItemsEnum["Separately"] = "SEPARATELY";
})(IShipBundleItemsEnum || (IShipBundleItemsEnum = {}));
/** Indicates whether to return results in ascending or descending order. */
export var ISortEnum;
(function (ISortEnum) {
    ISortEnum["Asc"] = "ASC";
    ISortEnum["Desc"] = "DESC";
})(ISortEnum || (ISortEnum = {}));
/** Specifies the field to use for sorting quote items */
export var ISortQuoteItemsEnum;
(function (ISortQuoteItemsEnum) {
    ISortQuoteItemsEnum["ItemId"] = "ITEM_ID";
    ISortQuoteItemsEnum["CreatedAt"] = "CREATED_AT";
    ISortQuoteItemsEnum["UpdatedAt"] = "UPDATED_AT";
    ISortQuoteItemsEnum["ProductId"] = "PRODUCT_ID";
    ISortQuoteItemsEnum["Sku"] = "SKU";
    ISortQuoteItemsEnum["Name"] = "NAME";
    ISortQuoteItemsEnum["Description"] = "DESCRIPTION";
    ISortQuoteItemsEnum["Weight"] = "WEIGHT";
    ISortQuoteItemsEnum["Qty"] = "QTY";
    ISortQuoteItemsEnum["Price"] = "PRICE";
    ISortQuoteItemsEnum["BasePrice"] = "BASE_PRICE";
    ISortQuoteItemsEnum["CustomPrice"] = "CUSTOM_PRICE";
    ISortQuoteItemsEnum["DiscountPercent"] = "DISCOUNT_PERCENT";
    ISortQuoteItemsEnum["DiscountAmount"] = "DISCOUNT_AMOUNT";
    ISortQuoteItemsEnum["BaseDiscountAmount"] = "BASE_DISCOUNT_AMOUNT";
    ISortQuoteItemsEnum["TaxPercent"] = "TAX_PERCENT";
    ISortQuoteItemsEnum["TaxAmount"] = "TAX_AMOUNT";
    ISortQuoteItemsEnum["BaseTaxAmount"] = "BASE_TAX_AMOUNT";
    ISortQuoteItemsEnum["RowTotal"] = "ROW_TOTAL";
    ISortQuoteItemsEnum["BaseRowTotal"] = "BASE_ROW_TOTAL";
    ISortQuoteItemsEnum["RowTotalWithDiscount"] = "ROW_TOTAL_WITH_DISCOUNT";
    ISortQuoteItemsEnum["RowWeight"] = "ROW_WEIGHT";
    ISortQuoteItemsEnum["ProductType"] = "PRODUCT_TYPE";
    ISortQuoteItemsEnum["BaseTaxBeforeDiscount"] = "BASE_TAX_BEFORE_DISCOUNT";
    ISortQuoteItemsEnum["TaxBeforeDiscount"] = "TAX_BEFORE_DISCOUNT";
    ISortQuoteItemsEnum["OriginalCustomPrice"] = "ORIGINAL_CUSTOM_PRICE";
    ISortQuoteItemsEnum["PriceIncTax"] = "PRICE_INC_TAX";
    ISortQuoteItemsEnum["BasePriceIncTax"] = "BASE_PRICE_INC_TAX";
    ISortQuoteItemsEnum["RowTotalIncTax"] = "ROW_TOTAL_INC_TAX";
    ISortQuoteItemsEnum["BaseRowTotalIncTax"] = "BASE_ROW_TOTAL_INC_TAX";
    ISortQuoteItemsEnum["DiscountTaxCompensationAmount"] = "DISCOUNT_TAX_COMPENSATION_AMOUNT";
    ISortQuoteItemsEnum["BaseDiscountTaxCompensationAmount"] = "BASE_DISCOUNT_TAX_COMPENSATION_AMOUNT";
    ISortQuoteItemsEnum["FreeShipping"] = "FREE_SHIPPING";
})(ISortQuoteItemsEnum || (ISortQuoteItemsEnum = {}));
export var ISpecialOfferTypeEnum;
(function (ISpecialOfferTypeEnum) {
    ISpecialOfferTypeEnum["ConditionalPurchase"] = "conditional_purchase";
    ISpecialOfferTypeEnum["FreeGiftFixed"] = "free_gift_fixed";
    ISpecialOfferTypeEnum["FreeGiftFlexible"] = "free_gift_flexible";
})(ISpecialOfferTypeEnum || (ISpecialOfferTypeEnum = {}));
/** Indicates the status of the request. */
export var ISubscriptionStatusesEnum;
(function (ISubscriptionStatusesEnum) {
    ISubscriptionStatusesEnum["NotActive"] = "NOT_ACTIVE";
    ISubscriptionStatusesEnum["Subscribed"] = "SUBSCRIBED";
    ISubscriptionStatusesEnum["Unsubscribed"] = "UNSUBSCRIBED";
    ISubscriptionStatusesEnum["Unconfirmed"] = "UNCONFIRMED";
})(ISubscriptionStatusesEnum || (ISubscriptionStatusesEnum = {}));
/** Swatch attribute metadata input types. */
export var ISwatchInputTypeEnum;
(function (ISwatchInputTypeEnum) {
    ISwatchInputTypeEnum["Boolean"] = "BOOLEAN";
    ISwatchInputTypeEnum["Date"] = "DATE";
    ISwatchInputTypeEnum["Datetime"] = "DATETIME";
    ISwatchInputTypeEnum["Dropdown"] = "DROPDOWN";
    ISwatchInputTypeEnum["File"] = "FILE";
    ISwatchInputTypeEnum["Gallery"] = "GALLERY";
    ISwatchInputTypeEnum["Hidden"] = "HIDDEN";
    ISwatchInputTypeEnum["Image"] = "IMAGE";
    ISwatchInputTypeEnum["MediaImage"] = "MEDIA_IMAGE";
    ISwatchInputTypeEnum["Multiline"] = "MULTILINE";
    ISwatchInputTypeEnum["Multiselect"] = "MULTISELECT";
    ISwatchInputTypeEnum["Price"] = "PRICE";
    ISwatchInputTypeEnum["Select"] = "SELECT";
    ISwatchInputTypeEnum["Text"] = "TEXT";
    ISwatchInputTypeEnum["Textarea"] = "TEXTAREA";
    ISwatchInputTypeEnum["Undefined"] = "UNDEFINED";
    ISwatchInputTypeEnum["Visual"] = "VISUAL";
    ISwatchInputTypeEnum["Weight"] = "WEIGHT";
})(ISwatchInputTypeEnum || (ISwatchInputTypeEnum = {}));
export var ITaxWrappingEnum;
(function (ITaxWrappingEnum) {
    ITaxWrappingEnum["DisplayExcludingTax"] = "DISPLAY_EXCLUDING_TAX";
    ITaxWrappingEnum["DisplayIncludingTax"] = "DISPLAY_INCLUDING_TAX";
    ITaxWrappingEnum["DisplayTypeBoth"] = "DISPLAY_TYPE_BOTH";
})(ITaxWrappingEnum || (ITaxWrappingEnum = {}));
/** 3D Secure mode. */
export var IThreeDsMode;
(function (IThreeDsMode) {
    IThreeDsMode["Off"] = "OFF";
    IThreeDsMode["ScaWhenRequired"] = "SCA_WHEN_REQUIRED";
    IThreeDsMode["ScaAlways"] = "SCA_ALWAYS";
})(IThreeDsMode || (IThreeDsMode = {}));
/** This enumeration defines the entity type. */
export var IUrlRewriteEntityTypeEnum;
(function (IUrlRewriteEntityTypeEnum) {
    IUrlRewriteEntityTypeEnum["CmsPage"] = "CMS_PAGE";
    IUrlRewriteEntityTypeEnum["Product"] = "PRODUCT";
    IUrlRewriteEntityTypeEnum["Category"] = "CATEGORY";
})(IUrlRewriteEntityTypeEnum || (IUrlRewriteEntityTypeEnum = {}));
/** Defines whether the attribute is filterable in layered navigation. */
export var IUseInLayeredNavigationOptions;
(function (IUseInLayeredNavigationOptions) {
    IUseInLayeredNavigationOptions["No"] = "NO";
    IUseInLayeredNavigationOptions["FilterableWithResults"] = "FILTERABLE_WITH_RESULTS";
    IUseInLayeredNavigationOptions["FilterableNoResult"] = "FILTERABLE_NO_RESULT";
})(IUseInLayeredNavigationOptions || (IUseInLayeredNavigationOptions = {}));
/** List of validation rule names applied to a customer attribute. */
export var IValidationRuleEnum;
(function (IValidationRuleEnum) {
    IValidationRuleEnum["DateRangeMax"] = "DATE_RANGE_MAX";
    IValidationRuleEnum["DateRangeMin"] = "DATE_RANGE_MIN";
    IValidationRuleEnum["FileExtensions"] = "FILE_EXTENSIONS";
    IValidationRuleEnum["InputValidation"] = "INPUT_VALIDATION";
    IValidationRuleEnum["MaxTextLength"] = "MAX_TEXT_LENGTH";
    IValidationRuleEnum["MinTextLength"] = "MIN_TEXT_LENGTH";
    IValidationRuleEnum["MaxFileSize"] = "MAX_FILE_SIZE";
    IValidationRuleEnum["MaxImageHeight"] = "MAX_IMAGE_HEIGHT";
    IValidationRuleEnum["MaxImageWidth"] = "MAX_IMAGE_WIDTH";
})(IValidationRuleEnum || (IValidationRuleEnum = {}));
/** A list of possible error types. */
export var IWishListUserInputErrorType;
(function (IWishListUserInputErrorType) {
    IWishListUserInputErrorType["ProductNotFound"] = "PRODUCT_NOT_FOUND";
    IWishListUserInputErrorType["Undefined"] = "UNDEFINED";
})(IWishListUserInputErrorType || (IWishListUserInputErrorType = {}));
/** A list of possible error types. */
export var IWishlistCartUserInputErrorType;
(function (IWishlistCartUserInputErrorType) {
    IWishlistCartUserInputErrorType["ProductNotFound"] = "PRODUCT_NOT_FOUND";
    IWishlistCartUserInputErrorType["NotSalable"] = "NOT_SALABLE";
    IWishlistCartUserInputErrorType["InsufficientStock"] = "INSUFFICIENT_STOCK";
    IWishlistCartUserInputErrorType["Undefined"] = "UNDEFINED";
})(IWishlistCartUserInputErrorType || (IWishlistCartUserInputErrorType = {}));
/** Defines the wish list visibility types. */
export var IWishlistVisibilityEnum;
(function (IWishlistVisibilityEnum) {
    IWishlistVisibilityEnum["Public"] = "PUBLIC";
    IWishlistVisibilityEnum["Private"] = "PRIVATE";
})(IWishlistVisibilityEnum || (IWishlistVisibilityEnum = {}));
export const AddBundleProductsToCartDocument = gql `
  mutation addBundleProductsToCart($cartId: String!, $cartItems: [BundleProductCartItemInput!]!) {
    addBundleProductsToCart(input: { cart_id: $cartId, cart_items: $cartItems }) {
      cart {
        id
      }
    }
  }
`;
export const AddConfigurableProductsToCartDocument = gql `
  mutation addConfigurableProductsToCart($cartId: String!, $sku: String!, $parentSku: String!, $quantity: Float!) {
    addConfigurableProductsToCart(
      input: { cart_id: $cartId, cart_items: [{ parent_sku: $parentSku, data: { quantity: $quantity, sku: $sku } }] }
    ) {
      cart {
        id
      }
    }
  }
`;
export const AddProductsToCartDocument = gql `
  mutation addProductsToCart($cartId: String!, $cartItems: [CartItemInput!]!) {
    addProductsToCart(cartId: $cartId, cartItems: $cartItems) {
      cart {
        id
      }
    }
  }
`;
export const AddSimpleProductsToCartDocument = gql `
  mutation addSimpleProductsToCart($cartId: String!, $cartItems: [SimpleProductCartItemInput!]!) {
    addSimpleProductsToCart(input: { cart_id: $cartId, cart_items: $cartItems }) {
      cart {
        id
      }
    }
  }
`;
export const ApplyCampaignToCartDocument = gql `
  mutation applyCampaignToCart($cartId: String!, $campaign_uuid: String!) {
    applyCampaignToCart(input: { cart_id: $cartId, campaign_uuid: $campaign_uuid }) {
      cart {
        applied_campaign {
          loyalty_discount_uuid
          loyalty_discount_points
          loyalty_discount_amount
        }
        id
        is_virtual
        items {
          product {
            sku
          }
          quantity
        }
      }
    }
  }
`;
export const ApplyCouponToCartDocument = gql `
  mutation applyCouponToCart($cartId: String!, $couponCode: String!) {
    removeCouponFromCart(input: { cart_id: $cartId }) {
      cart {
        id
      }
    }
    applyCouponToCart(input: { cart_id: $cartId, coupon_code: $couponCode }) {
      cart {
        applied_coupons {
          code
          label
        }
        can_apply_coupons
        messages
        prices {
          discounts {
            amount {
              currency
              value
            }
            label
            coupon_code
          }
        }
      }
    }
    cartCanApplyCoupons(input: { cart_id: $cartId })
  }
`;
export const CancelOrderDocument = gql `
  mutation cancelOrder($orderNumber: String!) {
    cancelorder(orderId: $orderNumber)
  }
`;
export const CreateEmptyCartDocument = gql `
  mutation createEmptyCart {
    createEmptyCart
  }
`;
export const GetCartIdDocument = gql `
  query getCartId($cartId: String!) {
    cart(cart_id: $cartId) {
      id
    }
  }
`;
export const GetCartItemsDocument = gql `
  query getCartItems($cartId: String!) {
    cart(cart_id: $cartId) {
      items {
        id
        errors {
          code
          message
        }
        has_registration_consent
        product {
          id
          name
          sku
          subscription
          has_registration_consent
          trade_in
          type_id
          stock_status
          has_device
          subscription_format
          promotionalOffers {
            code
            limit_qty
            eligible
            type
            skus
            description {
              title
              description
              hint
              label
            }
          }
          price_range {
            minimum_price {
              regular_price {
                value
                currency
              }
              final_price {
                value
                currency
              }
              fixed_product_taxes {
                label
                amount {
                  value
                  currency
                }
              }
            }
            maximum_price {
              discount {
                amount_off
                percent_off
              }
              fixed_product_taxes {
                label
                amount {
                  value
                  currency
                }
              }
            }
          }
          image {
            url
            label
          }
          short_description {
            html
          }
          flavor
          flavor_label
          enable_order_quantity_limit
          order_quantity_limit
          color_label
          categories {
            name
            uid
            store_locator_name
          }
          free_gifts {
            allowed_qty
            products {
              is_eligible
              eligibility_description
              product {
                name
                sku
                tooltip_info
                stock_status
                image {
                  url
                  label
                }
              }
            }
          }
        }
        quantity
        gift_data {
          is_gift
          parent_gift_sku
          parent_gift_id
        }
        prices {
          discounts {
            amount {
              currency
              value
            }
            label
          }
          price {
            currency
            value
          }
          row_total {
            currency
            value
          }
          row_total_including_tax {
            currency
            value
          }
          total_item_discount {
            currency
            value
          }
        }
        ... on BundleCartItem {
          bundle_options {
            id
            label
            type
            values {
              id
              label
              price
              quantity
              presentation_info {
                initial_price
                presentation_price
                product {
                  stock_status
                  tooltip_info
                  small_image {
                    url
                  }
                  price_range {
                    maximum_price {
                      final_price {
                        currency
                        value
                      }
                      regular_price {
                        currency
                        value
                      }
                    }
                    minimum_price {
                      final_price {
                        currency
                        value
                      }
                      regular_price {
                        currency
                        value
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;
export const GetCartPricesDocument = gql `
  query getCartPrices($cartId: String!) {
    cart(cart_id: $cartId) {
      subscription_amount
      shipping_addresses {
        selected_shipping_method {
          amount {
            currency
            value
          }
        }
      }
      applied_coupons {
        code
        label
      }
      applied_campaign {
        loyalty_discount_amount
        loyalty_discount_uuid
      }
      prices {
        grand_total {
          currency
          value
        }
        subtotal_excluding_tax {
          currency
          value
        }
        subtotal_including_tax {
          currency
          value
        }
        applied_taxes {
          amount {
            currency
            value
          }
          label
        }
        discounts {
          amount {
            currency
            value
          }
          label
          coupon_code
        }
      }
      total_after_trial {
        total {
          currency
          value
        }
        total_incl_tax {
          currency
          value
        }
        tax {
          currency
          value
        }
      }
      available_payment_methods {
        code
        title
      }
      minimum_payable_amount {
        currency
        value
      }
    }
  }
`;
export const GetCartSelectedPaymentMethodDocument = gql `
  query getCartSelectedPaymentMethod($cartId: String!) {
    cart(cart_id: $cartId) {
      selected_payment_method {
        purchase_order_number
      }
    }
  }
`;
export const GetConsumablesMatrixDocument = gql `
  query GetConsumablesMatrix {
    getConsumablesMatrix {
      packagingFormats {
        id
        label
        contentsType
        itemsPerPackage
        packagesPerBundle
        formatQuantity
        productTypeName
        icon
      }
      items {
        sku
        packagingFormatId
        purchaseType
        flavorDetails {
          flavour
          flavour_label
          swatch_data
        }
      }
    }
  }
`;
export const GetCountiesForProfileDocument = gql `
  query getCountiesForProfile {
    countries {
      available_regions {
        id
        code
        name
      }
      full_name_english
      full_name_locale
      id
      three_letter_abbreviation
      two_letter_abbreviation
    }
  }
`;
export const GetCountriesDocument = gql `
  query getCountries {
    countries {
      available_regions {
        id
        code
        name
      }
      full_name_english
      full_name_locale
      id
      three_letter_abbreviation
      two_letter_abbreviation
    }
  }
`;
export const GetCountryDocument = gql `
  query getCountry($id: String!) {
    country(id: $id) {
      id
      two_letter_abbreviation
      three_letter_abbreviation
      full_name_english
      full_name_locale
      available_regions {
        id
        code
        name
      }
    }
  }
`;
export const GetCouponsDocument = gql `
  query getCoupons($cartId: String!) {
    cart(cart_id: $cartId) {
      applied_coupons {
        code
        label
      }
      can_apply_coupons
      prices {
        discounts {
          amount {
            currency
            value
          }
          label
          coupon_code
        }
      }
    }
  }
`;
export const GetCurrencyDocument = gql `
  query getCurrency {
    currency {
      default_display_currency_code
      default_display_currency_symbol
    }
  }
`;
export const GetCustomerAddressesDocument = gql `
  query getCustomerAddresses {
    customer {
      default_shipping
      addresses {
        region {
          region
          region_code
          region_id
        }
        id
        country_code
        city
        company
        telephone
        firstname
        lastname
        middlename
        postcode
        street
      }
    }
  }
`;
export const GetCustomerCartDocument = gql `
  query getCustomerCart {
    customerCart {
      id
      available_payment_methods {
        code
        title
      }
      is_trial_eligible
      can_apply_coupons
      applied_campaign {
        loyalty_discount_uuid
        loyalty_discount_points
        loyalty_discount_amount
      }
    }
  }
`;
export const GetCustomerCartIdDocument = gql `
  query getCustomerCartId {
    customerCart {
      id
    }
  }
`;
export const GetCustomerCartPricesDocument = gql `
  query getCustomerCartPrices($cartId: String!) {
    cart(cart_id: $cartId) {
      email
      shipping_addresses {
        selected_shipping_method {
          amount {
            currency
            value
          }
          price_incl_tax {
            currency
            value
          }
          price_excl_tax {
            currency
            value
          }
        }
      }
      items {
        product {
          sku
          special_price
          price_range {
            minimum_price {
              regular_price {
                value
                currency
              }
              final_price {
                value
                currency
              }
              fixed_product_taxes {
                label
                amount {
                  value
                  currency
                }
              }
            }
            maximum_price {
              discount {
                amount_off
                percent_off
              }
              fixed_product_taxes {
                label
                amount {
                  value
                  currency
                }
              }
            }
          }
          price_tiers {
            quantity
            discount {
              percent_off
              amount_off
            }
            final_price {
              value
              currency
            }
          }
          name
          id
          uid
        }
        uid
        quantity
        product {
          name
          sku
          price_tiers {
            quantity
            final_price {
              value
            }
            discount {
              amount_off
              percent_off
            }
          }
        }
        prices {
          price {
            value
          }
        }
      }
      prices {
        discounts {
          label
          amount {
            value
          }
        }
        subtotal_including_tax {
          value
        }
        subtotal_excluding_tax {
          value
        }
        applied_taxes {
          label
          amount {
            value
          }
        }
        grand_total {
          currency
          value
        }
      }
      total_including_trial {
        total {
          currency
          value
        }
        total_incl_tax {
          currency
          value
        }
        tax {
          currency
          value
        }
      }
      total_after_trial {
        total {
          currency
          value
        }
        total_incl_tax {
          currency
          value
        }
        tax {
          currency
          value
        }
      }
      available_payment_methods {
        code
        title
      }
      minimum_payable_amount {
        currency
        value
      }
    }
  }
`;
export const GetCustomerExportedOrderDetailsDocument = gql `
  query getCustomerExportedOrderDetails($number: String!) {
    customer {
      orders(filter: { number: { eq: $number } }) {
        items {
          id
          order_date
          status
          items {
            product_name
            selected_options {
              label
              value
            }
            quantity_ordered
            quantity_refunded
            quantity_canceled
            product_sale_price {
              value
              currency
            }
            product_sale_price_incl_tax {
              currency
              value
            }
            product_sku
          }
          shipping_address {
            firstname
            lastname
            street
            city
            country_code
            postcode
            telephone
          }
          billing_address {
            firstname
            lastname
            street
            city
            country_code
          }
          shipping_method
          shipments {
            tracking {
              number
            }
          }
          payment_methods {
            type
            name
            additional_data {
              name
              value
            }
          }
          total {
            subtotal {
              currency
              value
            }
            taxes {
              amount {
                currency
                value
              }
            }
            discounts {
              label
              amount {
                currency
                value
              }
            }
            total_shipping {
              currency
              value
            }
            grand_total {
              value
              currency
            }
          }
          invoices {
            url
          }
        }
      }
    }
  }
`;
export const GetCustomerOrderDocument = gql `
  query getCustomerOrder($orderNumber: String!) {
    customer {
      orders(filter: { number: { eq: $orderNumber } }, scope: WEBSITE) {
        items {
          id
          items {
            id
            product_name
            product_sku
            quantity_ordered
            quantity_refunded
            quantity_canceled
            row_total {
              currency
              value
            }
            row_total_incl_tax {
              currency
              value
            }
            product_sale_price {
              currency
              value
            }
            product_sale_price_incl_tax {
              currency
              value
            }
            product_type
            gift_data {
              is_gift
              parent_gift_sku
              parent_gift_id
            }
            product {
              sku
              enable_order_quantity_limit
              order_quantity_limit
              subscription
              subscription_format
              categories {
                name
                uid
              }
              description {
                html
              }
              short_description {
                html
              }
              image {
                url
              }
              price_range {
                minimum_price {
                  regular_price {
                    value
                    currency
                  }
                  final_price {
                    value
                    currency
                  }
                  fixed_product_taxes {
                    label
                    amount {
                      value
                      currency
                    }
                  }
                }
                maximum_price {
                  discount {
                    amount_off
                    percent_off
                  }
                  fixed_product_taxes {
                    label
                    amount {
                      value
                      currency
                    }
                  }
                }
              }
            }
            ... on BundleOrderItem {
              bundle_options {
                id
                label
                values {
                  id
                  product_name
                  quantity
                  presentation_info {
                    initial_price
                    presentation_price
                    product {
                      tooltip_info
                      small_image {
                        url
                      }
                    }
                  }
                }
              }
            }
          }
          invoices {
            url
          }
          payment_methods {
            type
            name
            additional_data {
              name
              value
            }
          }
          additional_attributes {
            attribute_code
            value
          }
          billing_address {
            city
            country_code
            firstname
            lastname
            postcode
            street
            telephone
            administrative_area_level_2
            sublocality_level_2
            premise
            neighborhood
            landmark
            building_number
            district
            region
          }
          shipping_address {
            city
            country_code
            firstname
            lastname
            postcode
            street
            telephone
            pickup_information
            administrative_area_level_2
            sublocality_level_2
            premise
            neighborhood
            landmark
            building_number
            district
            region
          }
          carrier
          number
          order_date
          shipping_method
          shipping_method_code
          status
          loyalty_info {
            loyalty_discount_amount
            loyalty_discount_uuid
          }
          total {
            discounts {
              amount {
                currency
                value
              }
              label
              coupon_code
            }
            grand_total {
              currency
              value
            }
            subtotal {
              currency
              value
            }
            subtotal_incl_tax {
              currency
              value
            }
            shipping_handling {
              amount_including_tax {
                currency
                value
              }
              amount_excluding_tax {
                currency
                value
              }
            }
            taxes {
              amount {
                currency
                value
              }
              title
            }
            total_shipping {
              currency
              value
            }
            total_refunded {
              currency
              value
            }
            total_tax {
              currency
              value
            }
          }
          total_including_trial {
            total {
              currency
              value
            }
            total_incl_tax {
              currency
              value
            }
            tax {
              currency
              value
            }
          }
          total_after_trial {
            total {
              currency
              value
            }
            total_incl_tax {
              currency
              value
            }
            tax {
              currency
              value
            }
          }
        }
      }
    }
  }
`;
export const GetCustomerOrderDetailsDocument = gql `
  query getCustomerOrderDetails($number: String!, $scope: ScopeTypeEnum) {
    customer {
      orders(filter: { number: { eq: $number } }, scope: $scope) {
        items {
          id
          order_date
          website_code
          status
          status_reason {
            reason_code
            reason_message
          }
          items {
            id
            product {
              __typename
              color_label
              enable_order_quantity_limit
              order_quantity_limit
              hidden_sku
              subscription
              categories {
                name
                uid
              }
              image {
                url
              }
            }
            product_type
            product_name
            selected_options {
              label
              value
            }
            quantity_ordered
            quantity_refunded
            quantity_canceled
            row_total {
              currency
              value
            }
            row_total_incl_tax {
              currency
              value
            }
            product_sale_price {
              value
              currency
            }
            product_sale_price_incl_tax {
              currency
              value
            }
            product_sku
            gift_data {
              is_gift
              parent_gift_sku
              parent_gift_id
            }
            ... on BundleOrderItem {
              bundle_options {
                id
                label
                values {
                  uid
                  id
                  product_name
                  quantity
                  presentation_info {
                    initial_price
                    presentation_price
                    product {
                      uid
                      id
                      tooltip_info
                      small_image {
                        url
                      }
                    }
                  }
                }
              }
            }
          }
          additional_attributes {
            attribute_code
            value
          }
          shipping_address {
            firstname
            lastname
            street
            city
            country_code
            postcode
            telephone
            pickup_information
            administrative_area_level_2
            sublocality_level_2
            premise
            neighborhood
            landmark
            building_number
            district
            region
          }
          billing_address {
            firstname
            lastname
            street
            city
            postcode
            country_code
            administrative_area_level_2
            sublocality_level_2
            premise
            neighborhood
            landmark
            building_number
            district
            region
          }
          shipping_method
          loyalty_info {
            loyalty_discount_amount
            loyalty_discount_uuid
          }
          shipments {
            tracking {
              carrier
              number
              track_url
            }
          }
          payment_methods {
            type
            name
            method_code
            additional_data {
              name
              value
            }
          }
          total {
            subtotal {
              currency
              value
            }
            subtotal_incl_tax {
              currency
              value
            }
            taxes {
              amount {
                currency
                value
              }
            }
            discounts {
              label
              amount {
                currency
                value
              }
            }
            shipping_handling {
              amount_including_tax {
                currency
                value
              }
              amount_excluding_tax {
                currency
                value
              }
            }
            total_shipping {
              currency
              value
            }
            total_refunded {
              currency
              value
            }
            total_after_refund {
              currency
              value
            }
            grand_total {
              value
              currency
            }
          }
          total_after_trial {
            total {
              currency
              value
            }
            total_incl_tax {
              currency
              value
            }
            tax {
              currency
              value
            }
          }
          invoices {
            url
          }
        }
      }
    }
  }
`;
export const GetCustomerOrdersDocument = gql `
  query getCustomerOrders($filter: CustomerOrdersFilterInput) {
    customer {
      orders(filter: $filter) {
        items {
          id
          status
          shipping_method
          carrier
          order_date
          items {
            id
            product_name
            quantity_shipped
            quantity_refunded
            quantity_canceled
            row_total_incl_tax {
              currency
              value
            }
          }
          number
          total {
            grand_total {
              currency
              value
            }
            subtotal {
              currency
              value
            }
          }
        }
      }
    }
  }
`;
export const GetCustomerOrdersCountDocument = gql `
  query getCustomerOrdersCount($scope: ScopeTypeEnum) {
    customer {
      orders(scope: $scope) {
        total_count
      }
    }
  }
`;
export const GetCustomerOrdersPaginationDocument = gql `
  query getCustomerOrdersPagination(
    $filter: CustomerOrdersFilterInput
    $currentPage: Int
    $sort: CustomerOrderSortInput
    $scope: ScopeTypeEnum
    $order_type: OrderTypeEnum
  ) {
    customer {
      orders(filter: $filter, currentPage: $currentPage, sort: $sort, scope: $scope, order_type: $order_type) {
        page_info {
          current_page
          total_pages
        }
        items {
          id
          status
          shipping_method
          carrier
          order_date
          store_code
          website_code
          items {
            id
            product_name
            quantity_shipped
            product_subscription
          }
          payment_methods {
            type
            name
          }
          number
          shipments {
            tracking {
              track_url
            }
          }
          total {
            grand_total {
              currency
              value
            }
            subtotal {
              currency
              value
            }
          }
        }
      }
    }
  }
`;
export const GetCustomerOrdersStatusesDocument = gql `
  query getCustomerOrdersStatuses($filter: CustomerOrdersFilterInput) {
    customer {
      orders(filter: $filter) {
        items {
          id
          status
        }
      }
    }
  }
`;
export const GetOrderAttributesDocument = gql `
  query getOrderAttributes {
    getOrderAttributes {
      code
      label
      input_type
      data_type
      is_required
      min_length
      max_length
      validate_regex
      value
      description
      placeholder
      placement
      sort_order
    }
  }
`;
export const GetOrderDeliveryLimitsDocument = gql `
  query getOrderDeliveryLimits {
    getOrderDeliveryLimits {
      mode
      limits {
        id
        country_id
        name
      }
    }
  }
`;
export const GetOrderStatusesDocument = gql `
  query getOrderStatuses {
    getorderstatus {
      status_label
      status_value
      cancelable
    }
  }
`;
export const GetProductImageDocument = gql `
  query getProductImage($sku: String!) {
    products(filter: { sku: { eq: $sku } }) {
      items {
        sku
        image {
          url
        }
        small_image {
          url
        }
      }
    }
  }
`;
export const GetProductImageDescriptionDocument = gql `
  query getProductImageDescription($sku: [String]!) {
    products(filter: { sku: { in: $sku } }) {
      items {
        sku
        description {
          html
        }
        image {
          url
        }
      }
    }
  }
`;
export const GetProductPriceDocument = gql `
  query getProductPrice($sku: String!, $quantity: Int!) {
    getProductPrice(sku: $sku, quantity: $quantity) {
      maximum_price {
        final_price {
          currency
          value
        }
        regular_price {
          currency
          value
        }
      }
      minimum_price {
        final_price {
          currency
          value
        }
        regular_price {
          currency
          value
        }
      }
    }
  }
`;
export const GetProductsDocument = gql `
  query getProducts($sku: [String], $pageSize: Int) {
    currency {
      base_currency_code
      base_currency_symbol
    }
    products(filter: { sku: { in: $sku } }, pageSize: $pageSize) {
      aggregations {
        attribute_code
        label
        options {
          count
          label
          value
        }
      }
      items {
        sku
        __typename
        id
        name
        stock_status
        flavor
        flavor_label
        color
        subtitle
        product_disclaimer
        categories {
          name
        }
        flavour_details {
          name
          description
          attributes {
            id
            name
            sort_order
            value
          }
        }
        thumbnail {
          url
        }
        media_gallery {
          label
          url
          ... on ProductImage {
            role
          }
          ... on ProductVideo {
            video_content {
              video_title
              video_url
            }
          }
        }
        promotionalOffers {
          code
          limit_qty
          eligible
          potentially_eligible
          type
          skus
          description {
            title
            description
            hint
            label
          }
        }
        price_tiers {
          quantity
          discount {
            percent_off
            amount_off
          }
          final_price {
            value
            currency
          }
          total_price {
            value
            currency
          }
          label
        }
        price_range {
          minimum_price {
            final_prices {
              value
              currency
              multiplier
            }
            final_price {
              value
              currency
            }
            regular_price {
              value
              currency
            }
            discount {
              percent_off
            }
          }
        }
        ... on ConfigurableProduct {
          variants {
            product {
              sku
              name
              color
              stock_status
              flavor
              color_label
              subtitle
              product_disclaimer
              categories {
                name
              }
              price_range {
                minimum_price {
                  final_price {
                    value
                    currency
                  }
                  regular_price {
                    value
                    currency
                  }
                  discount {
                    percent_off
                  }
                }
              }
            }
          }
        }
        ... on BundleProduct {
          items {
            option_id
            title
            required
            type
            qty
            __typename
            sku
            options {
              id
              label
              qty
              quantity
              is_default
              product {
                id
                name
                sku
                flavor
                flavor_label
                subtitle
                stock_status
                color_label
                media_gallery {
                  label
                  url
                  ... on ProductImage {
                    role
                  }
                  ... on ProductVideo {
                    video_content {
                      video_title
                      video_url
                    }
                  }
                }
                categories {
                  name
                }
                price_range {
                  minimum_price {
                    final_price {
                      value
                      currency
                    }
                    regular_price {
                      value
                      currency
                    }
                    discount {
                      percent_off
                    }
                  }
                }
                __typename
              }
            }
            all_options {
              id
              label
              qty
              quantity
              is_default
              product {
                id
                name
                sku
                flavor
                flavor_label
                stock_status
                color_label
                subtitle
                flavour_details {
                  name
                  description
                  attributes {
                    id
                    name
                    sort_order
                    value
                  }
                }
                thumbnail {
                  url
                }
                media_gallery {
                  label
                  url
                  ... on ProductImage {
                    role
                  }
                  ... on ProductVideo {
                    video_content {
                      video_title
                      video_url
                    }
                  }
                }
                categories {
                  name
                }
                price_range {
                  minimum_price {
                    final_price {
                      value
                      currency
                    }
                    regular_price {
                      value
                      currency
                    }
                    discount {
                      percent_off
                    }
                  }
                }
                __typename
              }
            }
          }
        }
      }
    }
  }
`;
export const GetProductsEssentialsDocument = gql `
  query getProductsEssentials($sku: [String], $pageSize: Int) {
    currency {
      base_currency_code
      base_currency_symbol
    }
    products(filter: { sku: { in: $sku } }, pageSize: $pageSize) {
      items {
        sku
        __typename
        id
        name
        short_description {
          html
        }
        thumbnail {
          url
        }
        url_key
        stock_status
        ... on ConfigurableProduct {
          configurable_options {
            values {
              label
              swatch_data {
                value
              }
            }
          }
          variants {
            product {
              sku
              name
              stock_status
            }
          }
        }
        ... on BundleProduct {
          items {
            __typename
            sku
            options {
              id
              label
              product {
                id
                name
                sku
                stock_status
                __typename
              }
            }
          }
        }
      }
    }
    products_prices(filter: { sku: { in: $sku } }, pageSize: $pageSize) {
      total_count
      items {
        sku
        stock_status
        price_range {
          minimum_price {
            final_price {
              value
            }
            regular_price {
              value
            }
            discount {
              percent_off
            }
          }
        }
      }
    }
  }
`;
export const GetShippingMethodsDocument = gql `
  query getShippingMethods($cartId: String!) {
    cart(cart_id: $cartId) {
      shipping_addresses {
        available_shipping_methods {
          amount {
            currency
            value
          }
          available
          disable_for_subscription
          base_amount {
            currency
            value
          }
          carrier_code
          carrier_title
          method_code
          method_title
          description
          price_excl_tax {
            currency
            value
          }
          price_incl_tax {
            currency
            value
          }
        }
        selected_shipping_method {
          amount {
            currency
            value
          }
          carrier_code
          method_code
        }
      }
    }
  }
`;
export const GetSticksMatrixDocument = gql `
  query getSticksMatrix {
    getSticksMatrix {
      single_packs {
        onetime {
          flavour
          flavour_label
          sku
          swatch_data
        }
        subscription {
          flavour
          flavour_label
          sku
          swatch_data
        }
      }
      cartons {
        onetime {
          flavour
          flavour_label
          sku
          swatch_data
        }
        subscription {
          flavour
          flavour_label
          sku
          swatch_data
        }
      }
      mix_n_match {
        onetime {
          sku
        }
        subscription {
          sku
        }
      }
    }
  }
`;
export const GetStockStatusesDocument = gql `
  query getStockStatuses($sku: [String], $pageSize: Int) {
    products(filter: { sku: { in: $sku } }, pageSize: $pageSize) {
      items {
        sku
        __typename
        stock_status
        ... on ConfigurableProduct {
          variants {
            product {
              sku
              name
              stock_status
            }
          }
        }
        ... on BundleProduct {
          items {
            option_id
            title
            __typename
            sku
            all_options {
              id
              label
              product {
                id
                name
                sku
                stock_status
                __typename
              }
            }
          }
        }
      }
    }
  }
`;
export const GetStoreConfigDocument = gql `
  query getStoreConfig {
    storeConfig {
      id
      store_code
      store_group_code
      website_code
      is_order_limit_enabled
      is_age_verification_enabled
      is_free_gifts_enabled
      gift_basket_quantity_limitation
      order_limit_value
      base_currency_code
      postcode_validation_enabled
      postcode_is_required
      postcode_max_length
      postcode_min_length
      postcode_validate_regex
      allow_empty_firstname
      cartons_limit_value
    }
  }
`;
export const GetUrlKeysDocument = gql `
  query getUrlKeys($sku: String!) {
    products(filter: { sku: { eq: $sku } }) {
      items {
        url_key
        categories {
          url_path
        }
      }
    }
  }
`;
export const GetXSellingPopupDocument = gql `
  query GetXSellingPopup($cartId: String!) {
    cart(cart_id: $cartId) {
      xselling_popup
    }
  }
`;
export const MergeCartsDocument = gql `
  mutation mergeCarts($sourceCartId: String!, $destinationCartId: String!) {
    mergeCarts(source_cart_id: $sourceCartId, destination_cart_id: $destinationCartId) {
      id
    }
  }
`;
export const PlaceOrderDocument = gql `
  mutation placeOrder($cartId: String!, $additionalAttributes: [OrderAttributeInput]) {
    placeOrder(input: { cart_id: $cartId, additional_attributes: $additionalAttributes }) {
      order {
        entity_id
        order_number
      }
      errors {
        message
        code
      }
    }
  }
`;
export const RemoveCampaignFromCartDocument = gql `
  mutation removeCampaignFromCart($cartId: String!) {
    removeCampaignFromCart(input: { cart_id: $cartId }) {
      cart {
        applied_campaign {
          loyalty_discount_uuid
          loyalty_discount_points
          loyalty_discount_amount
        }
        id
        is_virtual
        items {
          product {
            sku
          }
          quantity
        }
      }
    }
  }
`;
export const RemoveCouponFromCartDocument = gql `
  mutation removeCouponFromCart($cartId: String!) {
    removeCouponFromCart(input: { cart_id: $cartId }) {
      cart {
        id
      }
    }
  }
`;
export const RemoveItemFromCartDocument = gql `
  mutation removeItemFromCart($cartId: String!, $itemId: Int!) {
    removeItemFromCart(input: { cart_id: $cartId, cart_item_id: $itemId }) {
      cart {
        id
      }
    }
  }
`;
export const SetAddressesOnCartDocument = gql `
  mutation setAddressesOnCart(
    $cartId: String!
    $shipping_addresses: CartAddressInput!
    $billing_address: CartAddressInput!
  ) {
    setShippingAddressesOnCart(input: { cart_id: $cartId, shipping_addresses: [{ address: $shipping_addresses }] }) {
      cart {
        id
      }
    }
    setBillingAddressOnCart(input: { cart_id: $cartId, billing_address: { address: $billing_address } }) {
      cart {
        id
      }
    }
  }
`;
export const SetBillingAddressOnCartDocument = gql `
  mutation setBillingAddressOnCart($cartId: String!, $address: CartAddressInput!) {
    setBillingAddressOnCart(input: { cart_id: $cartId, billing_address: { address: $address } }) {
      cart {
        id
      }
    }
  }
`;
export const SetBillingAddressOnCartByAddressIdDocument = gql `
  mutation setBillingAddressOnCartByAddressId($cartId: String!, $customer_address_id: Int!) {
    setBillingAddressOnCart(
      input: { cart_id: $cartId, billing_address: { customer_address_id: $customer_address_id } }
    ) {
      cart {
        id
      }
    }
  }
`;
export const SetPaymentMethodOnCartDocument = gql `
  mutation setPaymentMethodOnCart($cartId: String!, $code: String!) {
    setPaymentMethodOnCart(input: { cart_id: $cartId, payment_method: { code: $code } }) {
      cart {
        selected_payment_method {
          code
        }
      }
    }
  }
`;
export const SetShippingAddressesOnCartDocument = gql `
  mutation setShippingAddressesOnCart($cartId: String!, $address: CartAddressInput!) {
    setShippingAddressesOnCart(input: { cart_id: $cartId, shipping_addresses: [{ address: $address }] }) {
      cart {
        id
      }
    }
  }
`;
export const SetShippingAddressesOnCartByAddressIdDocument = gql `
  mutation setShippingAddressesOnCartByAddressId($cartId: String!, $customer_address_id: Int!) {
    setShippingAddressesOnCart(
      input: { cart_id: $cartId, shipping_addresses: [{ customer_address_id: $customer_address_id }] }
    ) {
      cart {
        id
      }
    }
  }
`;
export const SetShippingMethodsOnCartDocument = gql `
  mutation setShippingMethodsOnCart($cartId: String!, $carrierCode: String!, $methodCode: String!) {
    setShippingMethodsOnCart(
      input: { cart_id: $cartId, shipping_methods: [{ carrier_code: $carrierCode, method_code: $methodCode }] }
    ) {
      cart {
        id
      }
    }
  }
`;
export const UpdateCartItemQuantityDocument = gql `
  mutation updateCartItemQuantity($cartId: String!, $cartItemId: Int!, $quantity: Float!) {
    updateCartItems(input: { cart_id: $cartId, cart_items: [{ cart_item_id: $cartItemId, quantity: $quantity }] }) {
      cart {
        id
      }
    }
  }
`;
export const UpdateCustomerAddressDocument = gql `
  mutation updateCustomerAddress($addressId: Int!, $address: CustomerAddressInput!) {
    updateCustomerAddress(id: $addressId, input: $address) {
      city
      company
      country_code
      country_id
      default_billing
      default_shipping
      firstname
      id
      lastname
      middlename
      postcode
      prefix
      region {
        region
        region_code
        region_id
      }
      street
      suffix
      telephone
    }
  }
`;
export const UpdatePaymentMethodDocument = gql `
  mutation updatePaymentMethod($orderId: String!, $methodCode: String!) {
    updatePaymentMethod(input: { order_id: $orderId, method_code: $methodCode }) {
      success
    }
  }
`;
const defaultWrapper = (action, _operationName, _operationType) => action();
export function getSdk(client, withWrapper = defaultWrapper) {
    return {
        addBundleProductsToCart(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(AddBundleProductsToCartDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), "addBundleProductsToCart", "mutation");
        },
        addConfigurableProductsToCart(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(AddConfigurableProductsToCartDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), "addConfigurableProductsToCart", "mutation");
        },
        addProductsToCart(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(AddProductsToCartDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), "addProductsToCart", "mutation");
        },
        addSimpleProductsToCart(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(AddSimpleProductsToCartDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), "addSimpleProductsToCart", "mutation");
        },
        applyCampaignToCart(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(ApplyCampaignToCartDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), "applyCampaignToCart", "mutation");
        },
        applyCouponToCart(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(ApplyCouponToCartDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), "applyCouponToCart", "mutation");
        },
        cancelOrder(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(CancelOrderDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), "cancelOrder", "mutation");
        },
        createEmptyCart(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(CreateEmptyCartDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), "createEmptyCart", "mutation");
        },
        getCartId(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(GetCartIdDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), "getCartId", "query");
        },
        getCartItems(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(GetCartItemsDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), "getCartItems", "query");
        },
        getCartPrices(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(GetCartPricesDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), "getCartPrices", "query");
        },
        getCartSelectedPaymentMethod(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(GetCartSelectedPaymentMethodDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), "getCartSelectedPaymentMethod", "query");
        },
        GetConsumablesMatrix(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(GetConsumablesMatrixDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), "GetConsumablesMatrix", "query");
        },
        getCountiesForProfile(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(GetCountiesForProfileDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), "getCountiesForProfile", "query");
        },
        getCountries(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(GetCountriesDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), "getCountries", "query");
        },
        getCountry(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(GetCountryDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), "getCountry", "query");
        },
        getCoupons(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(GetCouponsDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), "getCoupons", "query");
        },
        getCurrency(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(GetCurrencyDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), "getCurrency", "query");
        },
        getCustomerAddresses(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(GetCustomerAddressesDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), "getCustomerAddresses", "query");
        },
        getCustomerCart(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(GetCustomerCartDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), "getCustomerCart", "query");
        },
        getCustomerCartId(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(GetCustomerCartIdDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), "getCustomerCartId", "query");
        },
        getCustomerCartPrices(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(GetCustomerCartPricesDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), "getCustomerCartPrices", "query");
        },
        getCustomerExportedOrderDetails(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(GetCustomerExportedOrderDetailsDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), "getCustomerExportedOrderDetails", "query");
        },
        getCustomerOrder(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(GetCustomerOrderDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), "getCustomerOrder", "query");
        },
        getCustomerOrderDetails(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(GetCustomerOrderDetailsDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), "getCustomerOrderDetails", "query");
        },
        getCustomerOrders(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(GetCustomerOrdersDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), "getCustomerOrders", "query");
        },
        getCustomerOrdersCount(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(GetCustomerOrdersCountDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), "getCustomerOrdersCount", "query");
        },
        getCustomerOrdersPagination(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(GetCustomerOrdersPaginationDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), "getCustomerOrdersPagination", "query");
        },
        getCustomerOrdersStatuses(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(GetCustomerOrdersStatusesDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), "getCustomerOrdersStatuses", "query");
        },
        getOrderAttributes(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(GetOrderAttributesDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), "getOrderAttributes", "query");
        },
        getOrderDeliveryLimits(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(GetOrderDeliveryLimitsDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), "getOrderDeliveryLimits", "query");
        },
        getOrderStatuses(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(GetOrderStatusesDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), "getOrderStatuses", "query");
        },
        getProductImage(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(GetProductImageDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), "getProductImage", "query");
        },
        getProductImageDescription(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(GetProductImageDescriptionDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), "getProductImageDescription", "query");
        },
        getProductPrice(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(GetProductPriceDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), "getProductPrice", "query");
        },
        getProducts(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(GetProductsDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), "getProducts", "query");
        },
        getProductsEssentials(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(GetProductsEssentialsDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), "getProductsEssentials", "query");
        },
        getShippingMethods(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(GetShippingMethodsDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), "getShippingMethods", "query");
        },
        getSticksMatrix(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(GetSticksMatrixDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), "getSticksMatrix", "query");
        },
        getStockStatuses(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(GetStockStatusesDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), "getStockStatuses", "query");
        },
        getStoreConfig(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(GetStoreConfigDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), "getStoreConfig", "query");
        },
        getUrlKeys(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(GetUrlKeysDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), "getUrlKeys", "query");
        },
        GetXSellingPopup(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(GetXSellingPopupDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), "GetXSellingPopup", "query");
        },
        mergeCarts(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(MergeCartsDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), "mergeCarts", "mutation");
        },
        placeOrder(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(PlaceOrderDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), "placeOrder", "mutation");
        },
        removeCampaignFromCart(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(RemoveCampaignFromCartDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), "removeCampaignFromCart", "mutation");
        },
        removeCouponFromCart(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(RemoveCouponFromCartDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), "removeCouponFromCart", "mutation");
        },
        removeItemFromCart(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(RemoveItemFromCartDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), "removeItemFromCart", "mutation");
        },
        setAddressesOnCart(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(SetAddressesOnCartDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), "setAddressesOnCart", "mutation");
        },
        setBillingAddressOnCart(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(SetBillingAddressOnCartDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), "setBillingAddressOnCart", "mutation");
        },
        setBillingAddressOnCartByAddressId(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(SetBillingAddressOnCartByAddressIdDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), "setBillingAddressOnCartByAddressId", "mutation");
        },
        setPaymentMethodOnCart(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(SetPaymentMethodOnCartDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), "setPaymentMethodOnCart", "mutation");
        },
        setShippingAddressesOnCart(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(SetShippingAddressesOnCartDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), "setShippingAddressesOnCart", "mutation");
        },
        setShippingAddressesOnCartByAddressId(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(SetShippingAddressesOnCartByAddressIdDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), "setShippingAddressesOnCartByAddressId", "mutation");
        },
        setShippingMethodsOnCart(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(SetShippingMethodsOnCartDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), "setShippingMethodsOnCart", "mutation");
        },
        updateCartItemQuantity(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(UpdateCartItemQuantityDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), "updateCartItemQuantity", "mutation");
        },
        updateCustomerAddress(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(UpdateCustomerAddressDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), "updateCustomerAddress", "mutation");
        },
        updatePaymentMethod(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(UpdatePaymentMethodDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), "updatePaymentMethod", "mutation");
        },
    };
}
const result = {
    possibleTypes: {
        AggregationOptionInterface: ["AggregationOption"],
        AttributeSelectedOptionInterface: ["AttributeSelectedOption"],
        AttributeValueInterface: ["AttributeSelectedOptions", "AttributeValue"],
        CartAddressInterface: ["BillingCartAddress", "ShippingCartAddress"],
        CartItemInterface: [
            "BundleCartItem",
            "ConfigurableCartItem",
            "DownloadableCartItem",
            "GiftCardCartItem",
            "SimpleCartItem",
            "VirtualCartItem",
        ],
        CategoryInterface: ["CategoryTree"],
        CreditMemoItemInterface: [
            "BundleCreditMemoItem",
            "CreditMemoItem",
            "DownloadableCreditMemoItem",
            "GiftCardCreditMemoItem",
        ],
        CustomAttributeMetadataInterface: [
            "AttributeMetadata",
            "CatalogAttributeMetadata",
            "CustomerAttributeMetadata",
            "ReturnItemAttributeMetadata",
        ],
        CustomAttributeOptionInterface: ["AttributeOptionMetadata"],
        CustomizableOptionInterface: [
            "CustomizableAreaOption",
            "CustomizableCheckboxOption",
            "CustomizableDateOption",
            "CustomizableDropDownOption",
            "CustomizableFieldOption",
            "CustomizableFileOption",
            "CustomizableMultipleOption",
            "CustomizableRadioOption",
        ],
        CustomizableProductInterface: [
            "BundleProduct",
            "ConfigurableProduct",
            "DownloadableProduct",
            "GiftCardProduct",
            "SimpleProduct",
            "VirtualProduct",
        ],
        ErrorInterface: ["InternalError", "NoSuchEntityUidError"],
        GiftRegistryDynamicAttributeInterface: ["GiftRegistryDynamicAttribute", "GiftRegistryRegistrantDynamicAttribute"],
        GiftRegistryDynamicAttributeMetadataInterface: ["GiftRegistryDynamicAttributeMetadata"],
        GiftRegistryItemInterface: ["GiftRegistryItem"],
        GiftRegistryItemUserErrorInterface: ["GiftRegistryItemUserErrors", "MoveCartItemsToGiftRegistryOutput"],
        GiftRegistryOutputInterface: ["GiftRegistryOutput", "MoveCartItemsToGiftRegistryOutput"],
        InvoiceItemInterface: ["BundleInvoiceItem", "DownloadableInvoiceItem", "GiftCardInvoiceItem", "InvoiceItem"],
        LayerFilterItemInterface: ["LayerFilterItem", "SwatchLayerFilterItem"],
        MediaGalleryInterface: ["ProductImage", "ProductVideo"],
        OrderItemInterface: ["BundleOrderItem", "DownloadableOrderItem", "GiftCardOrderItem", "OrderItem"],
        PaymentConfigItem: [
            "ApplePayConfig",
            "GooglePayConfig",
            "HostedFieldsConfig",
            "PaymentCommonConfig",
            "SmartButtonsConfig",
        ],
        PhysicalProductInterface: [
            "BundleProduct",
            "ConfigurableProduct",
            "GiftCardProduct",
            "GroupedProduct",
            "SimpleProduct",
        ],
        ProductInterface: [
            "BundleProduct",
            "ConfigurableProduct",
            "DownloadableProduct",
            "GiftCardProduct",
            "GroupedProduct",
            "SimpleProduct",
            "VirtualProduct",
        ],
        ProductLinksInterface: ["ProductLinks"],
        RoutableInterface: [
            "BundleProduct",
            "CategoryTree",
            "CmsPage",
            "ConfigurableProduct",
            "DownloadableProduct",
            "GiftCardProduct",
            "GroupedProduct",
            "RoutableUrl",
            "SimpleProduct",
            "VirtualProduct",
        ],
        ShipmentItemInterface: ["BundleShipmentItem", "GiftCardShipmentItem", "ShipmentItem"],
        SwatchDataInterface: ["ColorSwatchData", "ImageSwatchData", "TextSwatchData"],
        SwatchLayerFilterItemInterface: ["SwatchLayerFilterItem"],
        WishlistItemInterface: [
            "BundleWishlistItem",
            "ConfigurableWishlistItem",
            "DownloadableWishlistItem",
            "GiftCardWishlistItem",
            "GroupedProductWishlistItem",
            "SimpleWishlistItem",
            "VirtualWishlistItem",
        ],
    },
};
export default result;
//# sourceMappingURL=CodegenTypes.js.map